export const clinicCommon = {
  // General common
  Build: "Build",
  Create: "Create",
  DateCreated: "Date created",
  DateUpdated: "Date updated",
  Adherence: "Adherence",
  Author: "Author",
  AddedToPlan: "Added to plan",
  AddedAsSubstitute: "Added as substitute",
  RxEmptyState: {
    title: "No items added",
    description:
      "We help your {{patientTermPlural}} stay on track — refill reminders and flexible ordering options make {{patientTerm}} supplement planning easy.",
    rxUpdateDescription:
      "We help your {{patientTermPlural}} stay on track — refill reminders and auto refills make {{patientTerm}} supplement planning easy.",
  },
  EnlargeCatalogDrawer: {
    RxEmptyState: {
      rxUpdateDescription:
        "We help your {{patientTermPlural}} stay on track — refill reminders, flexible ordering options, and supporting documents make {{patientTerm}} supplement planning easy.",
      cta: "Add items",
    },
  },
  PoliciesPage: "Policies page",
  AddSupplements: "Add supplements",
  AddAPatient: "Add a {{patientTerm}}",
  PatientOrClient: "{{patientTerm}}",
  Dispensary: "Dispensary",
  YourProfitMargin: "Your profit margin",
  PatientLabelWithName: "<0>{{patientTermCapitalized}}: </0> {{patientName}}",
  PatientName: "{{patientTerm}} name",
  Attach: "Attach",
  AddAnAttachment: "Add an attachment",
  IncludeAPersonalMessage: "Click here to add a personal message",
  AddProducts: "Add products",
  SearchProducts: "Search products",
  SendPrescription: "Send {{treatmentPlanTerm}}",
  UpdatePrescription: "Update {{treatmentPlanTerm}}",
  UpdatePlan: "Update plan",
  UpdatePlans: "Update plans",
  NewPrescription: "New {{treatmentPlanTerm}}",
  CreatePrescription: "Create {{treatmentPlanTerm}}",
  CreateNewSection: "Create new section",
  LoadDraft: "Load draft",
  NewPrescriptionFrom: "New <0>{{treatmentPlanTerm}}</0> from <2>{{- practitionerName}}</2>",
  UpdatePrescriptionFrom: "Update <0>{{treatmentPlanTerm}}</0> from <2>{{- practitionerName}}</2>",
  RetailPrice: "Retail price",
  Price: "Price",
  Ingredients: "Ingredients",
  DailyConsumption: "Daily consumption",
  IngredientIntake: "Ingredient intake",
  DailyIntake: "Daily intake",
  Ingredient: "Ingredient",
  Quantity: "Quantity",
  SharedIngredients: "Shared ingredients ({{numOfIngredients}})",
  RemainingIngredientsWithCount: "Remaining ingredients ({{numOfIngredients}})",
  RemainingIngredients: "Remaining ingredients",
  OtherIngredients: "Other Ingredients",
  CategoricalMatch:
    "This product isn't an exact match, but is in a similar category to your current primary product.",
  ContributionToDailyIntake: "Contribution to daily intake",
  Collapse: "Collapse",
  IngredientsInThisTreatmentPlan: "Ingredients in this {{treatmentPlanTerm}}",
  ByIngredient: "By ingredient",
  ByProduct: "By product",
  new: "New",
  NewPrescriptionOnBehalfOf: "{{treatmentPlanTerm}} from",
  UpdatePrescriptionOnBehalfOf: "{{treatmentPlanTerm}} from",
  From: "From",
  AddPatient: "Add a {{patientTerm}} first",
  AddRecommendations: "Add products to the {{treatmentPlanTerm}} first",
  AddRecommendationsOrLabs: "Add at least one product or lab to send the plan",
  NothingChanged: "Nothing has changed in the plan",
  PlanCanceled: "Plan has been canceled",
  SaveAsDraft: "Save as draft",
  PrescriptionSentSuccessfully: "{{treatmentPlanTermCapitalize}} sent successfully",
  PrescriptionSent: "{{treatmentPlanTermCapitalize}} sent",
  FirstRxSent: {
    Congratulations: "Congratulations!",
    CongratsSentPrescription: "Congratulations! You've sent your first {{treatmentPlanTerm}}.",
    CanOrderProductsYouPrescribe:
      "Now {{- patientName }} can order the products you {{ treatmentPlanTermPastParticiple }}. Head to the <7>dashboard</7> to explore what else we have to offer!",
    neverMarginStoreDescirption:
      "Earn a profit margin and set up your {{patientTerm}} discounts in your <3>Dispensary settings.</3>",
    gambitExperiment: {
      completeAccountSetup: "Complete account setup",
      completeAccountSetupToOrder:
        "{{- patientName}} will be able to order the products you {{ treatmentPlanTermPastParticiple }} once you complete account setup.",
    },
  },
  DraftPrescriptionResetSuccessfully: "Draft {{treatmentPlanTerm}} reset successfully!",
  Preview: "Preview",
  PatientPreview: "{{patientTermCapitalized}} preview",
  PrescribeAndPlaceOrder: "{{treatmentPlanTermVerbCapitalize}} and place order",
  ResetDraft: "Reset draft",
  DurationNotSelectedOnProductsTitle: "Duration not selected on products (Optional)",
  DurationNotSelectedOnProductsDescription:
    "Duration provides the {{patientTerm}} a better understanding of their plan and an opportunity to enroll in <6>auto refills</6> to stay more adherent.",
  AutoshipByFullscriptMessage: {
    title: "Have you heard about auto refills by Fullscript?",
    description:
      "{{patientTerm}} can schedule auto refills and stay on track with your plan. Let them know by sharing this <3>auto refills</3> handout.",
    button: "Attach auto refills handout",
    buttonDisabled: "auto refills handout attached",
    successToast: "auto refills handout successfully attached!",
    errorToast: "There's something wrong, please try to attach again.",
  },
  ResetDraftAlertMessage:
    "This will remove all content from the {{treatmentPlanTerm}}. Are you sure you want to reset this draft?",
  DeleteDraftAlertMessage:
    "This will remove all content from the {{treatmentPlanTerm}}. Are you sure you want to delete this draft?",
  PrescriptionFor: "{{treatmentPlanTerm}} for {{- name}}",
  For: "For: {{- name}}",
  ShowHistory: "Show history",
  PrescriptionTotal: "{{treatmentPlanTerm}} total",
  StartsAt: "Starts at",
  TotalStartsAt: "Total starts at",
  Summary: "Summary",
  ProtocolTotal: "Protocol total",
  ProtocolName: "Protocol Name",
  savings: "Savings",
  Savings: "{{savings}}% savings",
  EditDiscount: "Edit discount",
  AssignPractitioner: "Assign a practitioner",
  UnassignPractitioner: "Unassign a practitioner",
  AssignPractitionerHeaader: "Assign a practitioner",
  AssignPractitionerDescription: "Choose a practitioner to assign to the selected patients.",
  UnassignPractitionerHeader: "Unassign a practitioner",
  UnassignPractitionerDescription:
    "Choose the practitioner you'd like to unassign from the selected patients.",
  PractitionerWillBeUnassgined: "{{- fullName}} will be unassigned within the next few minutes",
  PractitionerWillBeAssgined: "{{- fullName}} will be assigned within the next few minutes",
  NewPractitioner: "New practitioner",
  SelectPractitioner: "Select a practitioner",
  NoPractitionersFound: "Practitioner not found",
  SelectAll: "Select all ",
  SelectAllTrim: "Select all",
  EditTotalDiscount: "Edit total discount",
  DiscountChangesAreSaving: "Discount changes are saving",
  ChangesWillBeReflected:
    "Changes will be reflected for <1>{{totalRecords}}</1> {{patientTerm}} within the next few minutes. You may still use the app while you wait. Please refresh the page to view changes.",
  DiscountChangesSavedSuccessfully: "Discount changes saved successfully",
  TotalDiscountHasBeenUpdated:
    "Total discount has been updated for <1>{{totalRecords}}</1> {{patientTerm}}.",
  EditPatientsTotalDiscount: "Edit {{patientTermPlural}}' total discount",
  PatientsWillBeUpdated: " {{patientTerm}} will be updated",
  discountCannotBeEdited: "Discounts cannot be edited during {{patientTerm}} promotions",
  PleaseWaitWhileYourDiscountIsSaving: "Please wait while your discount changes are saving",
  PassAlongYourProfit:
    "Pass along your profit as an additional discount for your {{patientTermPlural}}. {{patientTermPluralCapitalized}} can receive up to <7>{{maxDiscount}}% off</7> by adding {{patientTerm}} and dispensary discounts.",
  PatientsReceivingMaxDiscountMessage:
    "{{patientTermPluralCapitalized}} are already receiving the maximum discount of {{maxDiscount}}%. Change your dispensary discount by visiting the <6>payments page</6>",
  PatientsReceivingMaxDiscount:
    "{{patientTermPluralCapitalized}} are already receiving the maximum discount of {{maxDiscount}}%",
  PatientDiscountCannotBeAdjusted:
    "{{patientTermCapitalized}} discount cannot be adjusted due to the {{maxDiscount}}% dispensary discount",
  DispensaryDiscount: "Dispensary discount",
  SavingsDiscount: "Savings ({{savings}}% discount)",
  SavingsStoreAndPatientExplained:
    "{{storeDiscount}}% store discount + {{patientDiscount}}% {{patientTerm}} discount",
  SavingsStoreExplained: "{{storeDiscount}}% store discount",
  SavingsPatientExplained: "{{patientDiscount}}% {{patientTerm}} discount",
  SaveAsDefault: "Save as default",
  SaveAsDefaultForFutureUse: "Save as default for future use",
  SelectAPatient: "Select a {{patientTerm}}",
  SelectPatient: "Select {{patientTerm}}",
  SelectAllPatients: "Select all {{patientTermPlural}}",
  Snippets: "Snippets",
  You: "You",
  Fullscript: "Fullscript",
  ExploreAllFullscriptTemplates: "Explore all Fullscript templates",
  ExploreAllMyTemplates: "Explore all my dispensary templates",
  ExploreTemplates: "explore templates",
  ExploreTemplatesCapital: "Explore templates",
  orExploreTemplates: "or <2>Explore templates</2>",
  TypeDosageInstructionsHere: "Type dosage instructions here...",
  AddDosageInstructions: "Add dosage instructions...",
  CloseModal: "Close modal",
  Close: "Close",
  Update: "Update",
  SignOut: "Sign out",
  referAColleague: "Refer a colleague",
  GenAIResearchAssistant: "Research assistant",
  StopImpersonatingTitle: "Stop impersonating",
  SwitchDispensary: "Switch account",
  AvatarFor: "Avatar for: ",
  AvatarForName: "Avatar for: {{- fullName}}",
  toggleAccountProfile: "Toggle profile account settings",
  YourPatient: "your {{patientTerm}}",
  ChangePhoto: "Change Photo",
  NoAvatarPhoto: "No avatar photo",
  AvatarPhoto: "Avatar photo for {{- fullName}}",
  Catalog: "Catalog",
  catalog: "Catalog",
  Search: "Search",
  SearchWithEllipsis: "Search...",
  PatientStatusFilter: "{{patientTermCapitalized}} Status",
  ShowLess: "Show less",
  ShowFewerIngredients: "Show fewer ingredients",
  ShowMore: "Show more",
  ShowMoreIngredients: "Show more ingredients",
  ShowMoreEllipsis: "... Show more",
  ShowLessEllipsis: "... Show less",
  WhatsNew: "See what's new!",
  WhatsNewOnly: "What's new",
  FullscriptBeta: "What do you think so far?",
  Feedback: "Feedback?",
  FeedbackDescription: "We're making improvements to Fullscript. We'd love to hear your feedback!",
  DontLikeIt: "Don't like it",
  AboutTheSame: "About the same",
  ILikeIt: "I like it!",
  ProvideFeedback: "Provide feedback",
  ViewReadOnly: "View read-only",
  PrescriptionOnly: "prescription only",
  PrescriptionOnlyBrand: "{{- brand}} ($t(PrescriptionOnly))",
  Breadcrumb: "Breadcrumb",
  ClickHere: "Click Here",
  Delete: "Delete",
  Edit: "Edit",
  Dismiss: "Dismiss",
  Cancel: "Cancel",
  CancelAction: "Cancel {{action}}",
  Send: "Send",
  Checkout: "Checkout",
  ExploreSupplements: "Explore supplements",
  GotIt: "Got it",
  HelpAndSupport: "Help & support",
  QuicklyFilter: "Quickly filter...",
  StartTreatmentPlan: "Start {{treatmentPlanTerm}}",
  Submit: "Submit",
  TermsOfService: "Terms of service",
  CaliforniaPrivacyNotice: "California privacy notice",
  Total: "Total",
  Restricted: "Restricted",
  AddProductsToTreatmentPlan: "Add products to {{treatmentPlanTerm}}",
  AddProductsToProtocol: "Add products to protocol",
  ExploreCatalogRx: "Explore the catalog, your favorites or {{patientTerm}} history",
  multiPatientPlanRestrictedBrandWarningTitle: "This brand has restricted access",
  multiPatientPlanTemplateRestrictedBrandWarningTitle:
    "This template has products with restricted access",
  multiPatientPlanRestrictedBrandWarningBody:
    "Products from this brand cannot be included in a multi-{{patientTerm}} plan. Please remove restricted products before switching to a multi-{{patientTerm}} plan.",
  multiPatientPlanTemplateRestrictedBrandWarningBody:
    "Products from this brand cannot be included in a multi-{{patientTerm}} plan. Please remove restricted products before adding to a multi-{{patientTerm}} plan.",
  UnassignedPatientsMessage:
    "You have {{totalCount}} {{patientTerm}} who isn't assigned to an active practitioner.",
  UnassignedPatientsMessage_plural:
    "You have {{totalCount}} {{patientTerm}} who aren't assigned to an active practitioner.",
  ViewPatients: "View {{patientTerm}}",
  RemindMeLater: "Remind me later",
  closePreviewDrawer: "close preview drawer",
  // Dates
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  // What's new modal - Protocols
  TitleOutWithTheOld: "Out with the old and in with the new!",
  DescriptionOutWithTheOld:
    "We've updated the layout, but we promise that we've done with you in mind. You can now see who a protocol is shared with along with who the protocol author is.",
  AltOutWithTheOld: "A minimalistic depiction of the new protocols list format.",
  TitleShareWithWhoever: "Share with whoever, whenever.",
  DescriptionShareWithWhoever: `Now, you can easily share your protocols with specific {{patients}} and staff members. Simply click "share" on the protocol to start giving access!`,
  AltShareWithWhoever:
    "A minimalistic depiction of the new share function for protocols which lists all patients and let's you select the ones you want to share with.",
  TitleCreateShareGo: "Create, share and go.",
  DescriptionCreateShareGo: `You can share protocols with specific {{patients}} from the prescription tool. To get started, select the arrow beside "Create protocol", and then select "Share with {{patients}}".`,
  AltCreateShareGo:
    "A button with a clickable arrow to the right of the text that shows you a submenu with options: 'Patient preview', 'Share with patients', 'Reset draft'",
  LastUpdated: "Last updated",
  Status: "Status",
  Created: "Created",
  // What's new modal - Catalog & Treatment
  IngredientSearch: "Ingredient search",
  TitleSearchByIngredients: "You can search by ingredients!",
  DescriptionSearchByIngredients:
    "Now, you can search and filter by a product name, its ingredients, brands, and supplement types. This will help you see what's out there, or more easily find a very specific product you're looking for.",
  AltSearchByIngredients:
    "An animated demonstration detailing the use of the new product search functionality, which allows you to search by product name, ingredients, supplement type, and brand name.",
  TitleSearchByIngredientsDetails: "Get specific. Like, really specific",
  DescriptionSearchByIngredientsDetails:
    "Looking for Vitamin D over 2000 IU? Or, a combination of Vitamin D and Vitamin C? You can now add multiple filters, narrowing your search to find the exact item you need.",
  AltSearchByIngredientsDetails:
    "An animated demonstration detailing the use of the filtered ingredient search, which allows you to filter search results based on the specific amount of ingredients found in those products.",
  TitleAttachments: "Add ready-made attachments",
  DescriptionAttachments:
    "Quickly and easily attach Fullscript wellness content to round-out your recommendations. You can now browse the Fullscript resource library and upload patient handouts, infographics, and other helpful guides directly into your treatment plan.",
  AltAttachments:
    "The attachments interface of the new RX tool showing multiple tabs and example documents you might need to interact with if attaching documents.",
  TitleResponsive: "Spread wellness from anywhere",
  DescriptionResponsive:
    "Now, you can stay connected to your patients and send recommendations from the office, home, or while you're on the go! The new prescribing tool is optimized for every device, including your phone.",
  AltResponsive:
    "Three rectangular boxes that vary in size which represent different screen sizes we have designed this tool for.",
  TitleFast: "The fastest prescribing tool available",
  DescriptionFast:
    "Write a script in seconds! The Rx tool is now 20x faster, meaning you can find a patient, find a product, and send a recommendation in less than a minute.",
  AltFast:
    "An animation that shows an example recommendation with items on the recommendation fading in one after the other",
  GetRestockReminder: "Email me when in stock",
  restrictedAccessMultiPatientPlan:
    "Restricted access. This brand cannot be added to a multi-{{patientTerm}} plan.",

  // What's new modal - Button Text
  MoreButtonText: "Show me more",
  DoneButtonText: "Got it!",

  // prescription saved modal
  StartAnotherPrescription: "Write another {{treatmentPlanTerm}}",
  GoToPrescriptionPage: "Go to {{treatmentPlanTerm}} page",
  ProceedToPatientCheckout: "Proceed to {{patientTerm}} checkout",
  ProceedToInOfficeCart: "Proceed to in-office cart",
  SentMessage: "Your {{treatmentPlanTerm}} for {{- firstName}} has been sent!",
  EmailMessage:
    "{{- firstName}} will get an email with your {{treatmentPlanTerm}}. They'll be prompted to sign into Fullscript, where they can order the products you've {{treatmentPlanTermPastParticiple}} and view any other resources in your {{treatmentPlanTerm}}. You can use the {{treatmentPlanTerm}} page to see when {{- firstName}} places their order. Also, we'll send {{- firstName}} refill reminders based on your dosage instructions so they can easily stay adherent – even without a follow-up appointment.",

  // Protocols
  SaveAsProtocol: "Save as protocol",
  SaveProtocol: "Save protocol",
  ProtocolSaved: "Protocol saved successfully!",
  SaveAsProtocolMessage:
    "Save this {{treatmentPlanTerm}} for future use and make {{treatmentPlanTermPresentParticiple}} faster and easier.",
  viewOnly: "View only",
  makeCopy: "Copy to my protocols",

  // Sections
  SectionName: "Section name",
  EditSectionBlurb:
    "Let {{patientFirstName}} know what this section is about - this will be displayed on their {{treatmentPlanTerm}}",
  SectionDetails: "Section details",
  SaveAndAddProducts: "Save and add products",
  SectionNameNotBlank: "Section name cannot be blank",
  SectionSavedSuccessfully: "Section saved successfully",

  // Avatar
  AvatarForPractitioner: "Avatar for {{- fullName}}",

  // Product Images
  ProductImageName: "{{- name}} product image",

  Remove: "Remove",
  RemoveAsSubstitute: "Remove as substitute",
  ProductRemoved: "Product removed",
  SaveRecommendationDetails: "Save dosage details",
  BasedOnYourDosageInstructions:
    "Based on your dosage instructions, your {{patientTerm}} will need at least {{extraUnitsRequired}} units. <5>{{treatmentPlanTermCapitalize}} {{extraUnitsRequired}} units</5>?",
  BasedOnYourDosageInstructionsNoSupply:
    "Based on your dosage instructions, your {{patientTerm}} will need at least {{extraUnitsRequired}} units, but you can only {{treatmentPlanTerm}} a maximum of {{backendMaxUnits}} units. <12>{{treatmentPlanTermCapitalize}} {{backendMaxUnits}} units</12>?",

  // Practitioner Terms
  Practitioner: "Practitioner",
  PatientTab: "{{patientTermCapitalize}}",
  PractitionerSeller: "Practitioner seller",
  Staff: "Staff",
  practitioner: "practitioner",
  practitionerPlural: "Practitioners",
  PractitionerName: "Practitioner name",
  StaffName: "Staff name",
  student: "student",
  student_capitalized: "Student",

  // Practitioner Types
  MedicalDoctor: "Medical Doctor",
  NaturopathicDoctor: "Naturopathic Doctor",
  RegisteredNurse: "Registered Nurse",

  // Edit Log
  CloseEditLog: "Close edit log",
  EditLog: "{{treatmentPlanTerm}} edit log",
  Draft: "Draft",
  Refresh: "Refresh",
  Active: "Active",

  // Add Protocols Modal
  Apply: "Apply",
  View: "View",
  ApplyProtocol: "Apply protocol",
  SearchAllProtocols: "Search all protocols...",
  ProtocolApplied: "Protocol applied",
  MessageApplied: "Message applied",
  ProductAdded: "Product added",
  Instructions: "Instructions",
  Attachments: "Attachments",
  Products: "Products",
  AttachmentApplied: "Attachment applied",
  AttachmentRemoved: "Attachment removed",
  ProtocolEmptyRecommendations: "There are no products associated with this protocol",
  ProtocolEmptyInstructions: "There are no instructions associated with this protocol",
  ProtocolEmptyAttachments: "There are no attachments associated with this protocol",
  ApplyTemplate: "Apply template",
  WontOverrideDosage: "We won't overwrite any existing dosage information.",
  AlreadyApplied: "This template has already been applied.",

  // Patient Modal or NewPatientPage
  LearnMoreAboutYourPatientExperience:
    "Learn more about your {{patientTerm}} experience with our patient preview",
  Tips: "Tips",
  GetPatientFeedbackWithAdherenceSurveys: "Get {{patientTerm}} feedback with adherence surveys",
  CreatingBatchListOfPatients:
    "Creating a batch list of {{patientTermPlural}}? Use our CSV import tool to create many {{patientTerm}} profiles at once. <5>Start your import</5>",
  Contact: "Contact",
  ParentDetails: "Parent details",
  AccountInformation: "Account information",
  ContactInformation: "Contact information",
  Dependents: "Dependents",
  CreateDependent: "Create dependent",
  FieldBlankError: "Cannot be blank or have opening spaces",
  EditPatient: "Edit {{patientTerm}}",
  CreatePatient: "Create {{patientTerm}}",
  SavePatient: "Save {{patientTerm}}",
  CreateNewPatient: "Create new {{patientTerm}}",
  NewPatient: "New {{patientTerm}}",
  PatientImport: "{{patientTerm}} import",
  ImportPatients: "Import {{patientTermPlural}}",
  PatientSeemsToBeNew: "{{- patientName }} seems to be new to your Fullscript account.",
  StartATreatmentPlanBelow: "Start a {{ treatmentPlanTerm }} below.",
  StartATreatmentPlanOrLabBelow: "Start a {{ treatmentPlanTerm }} or lab recommendation below.",
  PatientHasBeenAddedWithLabs:
    "{{- patientName}} has been added to your {{patientTerm}} list! Now you can write a lab, {{treatmentPlanTerm}}, or monitor adherence all in Fullscript.",
  PatientHasBeenAdded:
    "{{- patientName}} has been added to your {{patientTerm}} list! Now you can write a {{treatmentPlanTerm}} or monitor adherence all in Fullscript.",
  FirstPatientCreatedModal: {
    patientCreatedSuccessfully: "Congratulations! You've added your first {{patientTerm}}.",
    patientCreatedDescription:
      "Next, you can write a {{treatmentPlanTerm}} for <4>{{- createdPatientName}}</4> to start their path to wellness with Fullscript.",
  },
  PatientCreatedSuccessfully: "{{patientTermCapitalized}} created successfully!",
  PatientCreatedDescription:
    "{{- createdPatientName}} has been added to your {{patientTerm}} list! Now you can write a {{treatmentPlanTerm}} any time and monitor adherence in Fullscript.",
  LinkedPatientCreatedDescription:
    "<0>{{- createdPatientName}}</0> has been added to your {{patientTerm}} list! Now you can write a {{treatmentPlanTerm}} any time and monitor adherence in Fullscript.",
  CreateAnotherPatient: "Create another {{patientTerm}}",
  SendEmailDescription:
    "We'll send an email explaining that you've set up your <1>{{patientTerm}}</1> on Fullscript. <4>Preview email</4>",
  SendEmailDescriptionShort:
    "We'll send an email explaining that you've set up your {{patientTerm}} on Fullscript.",
  PreviewEmail: "Preview email",
  CreatePatientAndStartPrescription: "Create and start {{treatmentPlanTerm}}",
  DidYouKnow: "Did you know?",
  FullscriptHas:
    "Fullscript has a CSV import tool you can use to create many {{patientTerm}} profiles at once. Creating a batch list of {{patientTermPlural}}? <4>Start your import</4>",
  ArchivePatient: "Archive {{patientTerm}}",
  RestorePatient: "Restore {{patientTerm}}",
  ShowArchived: "Show Archived",
  Archived: "Archived",
  Archive: "Archive",
  ArchivedPractitionerCannotBeAssigned: "Can't assign an archived practitioner",
  Profile: "Profile",
  Details: "Details",
  Save: "Save",
  Next: "Next",
  UsingAgain: "Using again? Save for later",
  DateWrongFormat: "Date should be in proper ranges",
  FutureDate: "Date cannot be in future",
  PatientCreated: "{{patientTermCapitalized}} successfully created",
  PatientCreatedError: "Something went wrong. Please try again",
  PatientModalError: "Something went wrong. Please try again",
  PatientUpdated: "{{patientTermCapitalized}} updated successfully",
  DateOfBirth: "Date of birth",
  CloseDateOfBirth: "Close date of birth",
  AddDateOfBirth: "+ Date of birth",
  AddBiologicalSex: "+ Biological sex",
  CloseBiologicalSex: "Close biological sex",
  BiologicalSex: "Biological Sex",
  Male: "Male",
  Female: "Female",
  PreferNotToSay: "Prefer not to say",
  DisabledDiscountTooltip:
    "You're already offering this {{patientTerm}} the maximum available discount or discount is locked due to the store wide promotion!",
  FrozenDiscountTooltip: "Your store has locked discounts.",
  ApplyPatientDiscount: "+ {{patientTermCapitalized}} discount",
  CloseDiscount: "Close additional product discount",
  Discount: "Discount",
  discount: "discount",
  Discounts: "Discounts",
  NumberPatientsDiscountExceeding:
    "{{count}} {{patientTerm}} with a first order discount have their total discount exceeding 35% and this update won't be applied to them.",
  PatientDiscount: "{{patientTermCapitalized}} discount",
  AdditionalSavings: "Additional product savings",
  Optional: "Optional",
  optional: "optional",
  SupplementPrescribing: "Supplement {{treatmentPlanTermPastParticiple}}",
  LabRecommendations: "Lab recommendations",
  AdditionalInformation: "Additional information",
  Select: "Select",
  SelectOne: "Select one",
  Selected: "Selected",
  selected: "selected",
  staff: "staff",
  DiscountPercentage: "{{discount}}%",
  FirstOrderDiscount: {
    ExcludingFirstOrderDiscounts: "(excluding first order discounts)",
    label: "1st product order discount",
    descriptiveText:
      "This is applied onto this {{patientTerm}}'s first order and will be added to the total discount ({{patientTermCapitalized}} + Dispensary)",
    close: "Close 1st product order discount",
    apply: "+ 1st product order discount",
    totalPatientDiscount:
      "Dispensary: {{storeDiscount}}% + {{patientTermCapitalized}} discount: {{patientDiscount}}% + 1st product order: {{firstOrderDiscount}}%",
    disabled:
      "You're already offering this {{patientTerm}} the maximum available discount or discount is locked due to the store wide promotion!",
  },
  SendWelcomeEmail: "Send a welcome email",
  PatientEmailPreviewText1:
    "We send an email when a {{patientTerm}} is added to Fullscript asking them to set up a password to create their account.",
  PatientEmailPreviewText2: "Your emails will appear to your {{patientTermPluralized}} as such:",
  PatientEmailPreviewFrom: "<0>From</0>: Fullscript",
  IntakePatientEmailPreview: {
    SubjectLine: "<0>Subject line</0>: Join {{- practitionerFullName}} on Fullscript",
    AltImageText: "Invitation to join Fullscript example email",
    Header: "Invite email preview",
    Body1: "Send an invite email to notify patients they have access to your Fullscript dispensary",
    Body2: "Your emails will appear as such:",
  },
  AttachResources: "Attach {{patientTerm}} resources",
  ReadOnlyView: "Read-only view",

  // Additional Fields
  PatientDiscountText:
    "Pass along your profit as an additional discount. This will be added on top of your {{percentage}}% dispensary discount",
  AdditionalPhoneNumberText: "A plan sent via text message converts better than email alone",
  AdditionalField: "+ {{- fieldName}}",
  SearchUsersByName: "Search by {{userTerm}} name...",
  NoResultsFound: "No results found",
  NoTemplatesCreated: "No templates created",
  WhenYouCreateTemplates: "When you create any templates, you'll see them here.",
  NoAllTemplatesFound: 'No results for "{{- searchTerm}}" in all templates',
  NoFullscriptTemplatesFound: 'No results for "{{- searchTerm}}" in Fullscript templates',
  NoMyDispensaryTemplatesFound: 'No results for "{{- searchTerm}}" in your dispensary templates',
  SearchAllTemplates: "Search all templates",
  NoPatient: "No {{patientTerm}}",
  RefineSearchToSeeMore: "Refine search to see more results",
  NoUsersFound:
    'It looks like there are no results for "{{- queryTerm}}". Try clearing your search or creating a new {{userTerm}}.',
  NoProtocolsFound:
    'It looks like there are no results for "{{- searchTerm}}", try clearing your search, or creating a new protocol',
  NoResultsForSearch:
    'It looks like there are no results for "{{- queryTerm}}". Try clearing your search.',
  NoUsersYet: "{{- pracName}} doesn't have any existing  {{userTermPlural}}",
  NoUsers: "No existing {{userTermPlural}}",
  ClearSearch: "Clear search",
  WhenYouCreateUser: "When you create new {{userTermPlural}}, they will be available here",
  CreateFirstUser: "Create first {{userTerm}}",
  // Prescription Message
  AddMessage: "Add message",
  SaveTimeWithMessageTemplates: "Save time with message templates:",

  // No Patient Empty State Prescribing
  StartPrescriptionCreatePatient:
    "Start your first {{treatmentPlanTerm}} by creating a new {{patientTerm}}",
  CreateANewPatient: "Create a new {{patientTerm}}",
  ContinueWithoutPatient: "Continue without a {{patientTerm}}",

  // Input Field Labels
  firstName: "First name",
  lastName: "Last name",
  firstAndLastName: "First and last name",
  email: "Email",
  npiNumber: "NPI number",
  LicenseState: "License state",
  LicenseDegree: "License degree",
  LicenseNumber: "License number",
  LicenseExpiryDate: "License expiry date",
  LicenseInformation: "License information",
  NameMustMatchNpi: "First and last name must match the name on your NPI",
  LicenseInformationRequiredLabs: "License information is required to order certain lab tests",
  phoneNumber: "Phone number",
  ExpiryDateNotInFuture: "Expiry date needs to be in the future",
  phoneNumberOptional: "Phone number (optional)",
  searchPatient: "Search {{patientTerm}}",

  // Catalog Drawer
  CloseCatalog: "Close the catalog overlay",

  CommonlyPrescribed: "My frequently {{treatmentPlanTermPastParticiple}} products",
  CommonlyRecommended: "My frequently recommended products",
  Favorites: "Favorites",
  LabKits: "Lab kits",
  Manage: "Manage",
  ManageFavorites: "Favorites",
  favorites: "Favorites",
  AllFavorites: "All favorites",
  AddToFavorites: "Add to favorites",
  AddToPrescription: "Add to prescription",
  AddToProtocol: "Add to protocol",
  DeleteCategory: "Delete category",
  CategoryName: "Category name",
  CreateNewCategory: "Create a new favorites category",
  EditCategory: "Edit category",
  FavoriteCategoriesDescription:
    "Favorite categories help you keep things more organized and easy to find.",
  Suggestions: "Suggestions:",
  SuggestionsNoColon: "Suggestions",
  CategoryLabel: "<0>Category</0>: {{- label}}",
  CreateCategory: "Create category",
  CategoryCreatedSuccessfully: "Category created successfully!",
  CategoryUpdatedSuccessfully: "Category updated successfully!",
  CategoryDeletedSuccessfully: "Category deleted successfully!",
  AddToACategory: "Add to {{- categoryName}}",
  AlreadyInCategory: "Already in {{- categoryName}}",
  AddedToACategory: "Added to {{- categoryName}}",
  AreYouSureYouWantToDeleteCategory: `Are you sure you want to delete your category "{{- category}}"?`,
  BackToCatalog: "Back to catalog",
  BackToFavorites: "Back to favorites",
  BackToProtocols: "Back to protocols",
  BackToResources: "Back to resources",
  BackToProductDetails: "Back to product details",
  BackToDailyPack: "Back to daily pack",
  BackToDailyPacks: "Back to daily packs",
  BackToOtherOptions: "Back to other options",
  BackToDailyPackItems: "Back to daily pack items",
  BackToDailyPackProducts: "Back to daily pack products",
  OnlyShowFavorites: "Only show favorites",
  BackToPatientHistory: "Back to patient history",
  PatientHistory: "Patient history",
  patient_history: "Patient history",
  dailypacks: "Daily packs",
  BuildYourDailyPack: "Build your daily pack",
  resources: "Resources",
  Template: "Template",
  Templates: "Templates",
  PatientsActivePrescriptions: "Active {{treatmentPlanTermPlural}} for {{- name}}",
  EmptyPatientHistory: "{{- name}} does not have any active {{treatmentPlanTermPlural}}.",
  NoPatientSelectedPatientHistoryTitle: "Select a {{patientTerm}} for this {{treatmentPlanTerm}}",
  NoPatientSelectedPatientHistoryDescription:
    "Once selected, you'll be able to view all of their active {{treatmentPlanTermPlural}} and add previously {{treatmentPlanTermPastParticiple}} products from here.",
  NumberOfProduct: "{{count}} product",
  NumberOfProduct_plural: "{{count}} products",
  AddAllProducts: "Add all products",
  AddProduct: "Add 1 product",
  AddProduct_plural: "Add {{count}} products",
  AllProductsAdded: "All products were added successfully",
  QuantityAddedToTreatmentPlan: "{{dosageQuantity}} added",
  SimilarProducts: "Similar products",
  EmptyRecommendedTogetherProducts:
    "It looks like there are no <1>recommended together</1><2/><3>products</3> available",
  RecommendedTogetherProductsDescription:
    "The following products are often {{treatmentPlanTerm}} with <1>{{productName}}</1> by practitioners on Fullscript",
  RecommendedTogether: "{{treatmentPlanTermCapitalized}} together",
  SuggestionsRecommendedTogether: "Suggestions",
  SmartSuggestions: "Smart suggestions",
  SmartSuggestionsDescription: "We found similar alternatives to the above product.",
  SmartSuggestionTagTooltip: {
    lower_cost: "This product costs ${{ altCost }} / month compared to ${{ baseCost }} / month.",
    higher_repurchase_rate:
      "This product has a patient repurchase rate of {{ altRepurchaseRate }}% compared to {{ baseRepurchaseRate }}%.",
    fewer_pills:
      "This product has a comparable dosage at {{ altAmount }} {{altFormat}} compared to {{ baseAmount }} {{ baseFormat}}.",
  },
  FSTestedTagTooltip: "Third-party tested",
  FrequentlySentWith: "Frequently sent with",
  FrequentlySentWithDescription:
    "Practitioners on Fullscript frequently send the following products with {{- productName}}",
  SwapWithProduct: "Swap with this product",
  AddAsSubstitute: "Add as substitute",
  UnswapSuccess: "Product was unswapped",
  ProductSwapsNeeded: "Product swaps needed",
  ProductSwapsNotNeeded: "No swaps needed right now",
  ProductSwapsNotNeededDescription:
    "Products you've recently {{treatmentPlanTermPastParticiple}} that need to be swapped will show here. Simply select a new product and we'll email your {{patientTermPlural}} to let them know.",
  ProductSwapsNeededDescription: "Select which product you would like to swap",
  ProductSwapsLearnMore: "Learn more about product swapping",
  SimilarProductsDescription: "Curated by Fullscript's Medical Advisory team",
  PopularProducts: "Popular products",
  ActivePrescriptions: "{{count}} active {{treatmentPlanTerm}}",
  Plan: "Plan",
  plan: "plan",
  plans: "plans",
  plan_plural: "plans",
  ActivePlan: "{{count}} active plan",
  ActivePlans: "Active plans",
  ActivePlansCount: "{{count}} active plans",
  PercentDiscount: "{{discount}}% total discount",
  TotalDiscount: "Total discount",
  TotalPatientDiscount: "Dispensary: {{storeDiscount}}% + Individual: {{patientDiscount}}%",
  NoRecentPatients:
    "It looks like you haven't {{treatmentPlanTermPastParticiple}} this product before",
  EmptyFavoriteProducts: "It looks like you don't have any <1>favorite</1> products yet",
  EmptyFavouriteProducts: "It looks like you don't have any <1>favorite</1> products yet",
  catalogDrawer: {
    authorPrefix: "Show",
    fullscript: "Fullscript-created",
    myUploads: "My uploads",
    all: "All resources",
  },

  // Product
  Unit: "unit",
  Unit_plural: "units",
  Each: "each",
  PerUnit: " / Unit",
  PerServing: " / Serving",
  PleaseTake: "Please take ",
  Take: "Take",
  Serving: " serving",
  Serving_plural: " servings",
  Capsule: "capsule",
  Capsule_plural: "capsules",
  Tablet: "tablet",
  Tablet_plural: "tablets",
  Drop: "drop",
  Drop_plural: "drops",
  Scoop: "scoop",
  Scoop_plural: "scoops",
  Packet: "packet",
  Packet_plural: "packets",
  PricePerUnit:
    '{{ unitsToPurchase }} $t(Unit, {"count": {{ unitsToPurchase }} }) (${{ price }}) $t(Each)',
  Gel: "gel",
  Gel_plural: "gels",
  Pellet: "pellet",
  Pellet_plural: "pellets",
  Teaspoon: "teaspoon",
  Teaspoon_plural: "teaspoons",
  Tablespoon: "tablespoon",
  Tablespoon_plural: "tablespoons",
  Chew: "chew",
  Chew_plural: "chews",
  Lozenge: "lozenge",
  Lozenge_plural: "lozenges",
  Milliliter: "milliliter",
  Milliliter_plural: "milliliters",
  Tsp: "tsp",
  Tsp_plural: "tsps",
  Softgel: "softgel",
  Softgel_plural: "softgels",
  Dropper: "dropper",
  Dropper_plural: "droppers",
  Sachet: "sachet",
  Sachet_plural: "sachets",
  Ml: "ml",
  Ml_plural: "mls",
  Strip: "strip",
  Strip_plural: "strips",
  Gummy: "gummy",
  Gummy_plural: "gummies",
  Vegcap: "vegcap",
  Vegcap_plural: "vegcaps",
  Tab: "tab",
  Tab_plural: "tabs",
  Teaspoonful: "teaspoonful",
  Teaspoonful_plural: "teaspoonfuls",
  Cap: "cap",
  Cap_plural: "caps",
  ToggleAdditionalNotes: "Toggle additional notes",
  AdditionalNotes: "Additional notes",
  AddAdditionalNotes: "Add additional notes here...",
  AddNote: "Add note",
  AddNotes: "Add notes",
  CloseNote: "Close note",
  AddingToCart: "Adding to cart...",
  BuyWholesale: "Buy wholesale",
  BuyWholesaleOutOfStock: "Buy wholesale (out of stock)",
  Wholesale: "Wholesale",
  WholesaleCatalog: "Wholesale catalog",
  Shop: "Shop",
  WholesaleOrders: "Wholesale orders",
  WholesalePolicies: "wholesale policies",
  WholesalePoliciesCapital: "Wholesale policies",
  Unavailable: "Unavailable",
  GoToWholeSalePolicies: "Go to wholesale policies",

  // Frequency
  Frequency: "Frequency",
  OncePerDay: "Once / day",
  TwicePerDay: "Twice / day",
  ThreeTimesPerDay: "Three times / day",
  FourTimesPerDay: "Four times / day",
  FiveTimesPerDay: "Five times / day",
  EveryMorning: "Every morning",
  EveryNight: "Every night",
  EveryMorningAm: "Every morning (AM)",
  EveryNightPm: "Every night (PM)",
  OnceADay: "once per day",
  PerDay: "per day",
  frequencyTimesAnytime: "x {{ frequency }} / anytime",
  timesPerDayAnytime: "x {{ frequency }} times per day / anytime",
  takeWith: "Take with {{ takeWith }}",
  takeWithAn: "Take with an {{ takeWith }}",

  // Product Swap
  AddSubstitutes: "Add substitutes",
  EditSubstitutes: "Edit substitutes",
  ViewSubstitutes: "View substitute product",
  ViewSubstitutes_plural: "View substitute products",
  SelectReplacement: "Select a replacement",
  delayed: "Delayed",
  discontinued: "Unavailable",
  swapProduct: "Swap product",

  // Dosage Type
  Dosage: "Dosage",
  Dose: "Dose",
  DosageAmountAndFormat: "{{ amount }} {{ format }}",
  EditDosage: "Edit dosage",
  AddDosage: "Add dosage...",
  SaveAsDefaultDosage: "Save as default dosage",
  CustomDosageSuccess: "Dosage saved as default",
  CustomDosageError: "Select a duration or add an instruction to save as default",
  Supplier: "Supplier",
  TextOnly: "Text only",
  SupplierDosage: "Supplier dosage",
  TextOnlyDosage: "Text only dosage",
  UseSavedDosage: "Use saved dosage",
  CustomDosage: "Custom dosage",
  DosageUnavailable: "Dosage unavailable",
  ApplySupplierDosage: "Apply supplier dosage",
  NoDosageAssigned: "No dosage instructions assigned.",
  MustHaveInstructions: "Must have instructions",

  // Format
  Format: "{{format}}",
  Format_plural: "{{format}}s",

  PerMonth: "per month",
  PerMonthShort: " / Month",

  // Patient Preview
  PatientPreviewTitle: "What {{- name}} will see",
  PatientPreviewEmail:
    "Here's a look at what your {{patientTerm}} will see from the point of signing up for Fullscript all the way to placing their order.",
  PatientPreviewSignInButton: "How they sign in",
  PatientPreviewSignIn:
    "{{- name}} will be asked to sign in online. The sign in process is super easy - the {{patientTerm}} just needs to provide their name, and email associated with the account.",
  PatientPreviewAccessButton: "Accessing the {{treatmentPlanTerm}}",
  PatientPreviewAccess:
    "The {{treatmentPlanTerm}} is shown with the practitioner's name, the message provided (if any), along with your attachments and products. From here, the {{patientTerm}} can click  \"add all to cart\" where they'll be guided through our easy to use checkout.",
  PatientPreviewShipmentButton: "Shipment",
  PatientPreviewShipment:
    "Our products are shipped via USPS and UPS. Delivery times range depending on the {{patientTermPlural}}' delivery preferences. We take care of heat sensitive items with cold packs.",

  // Protocol Patient Preview
  ProtocolPatientPreviewTitle: "What they will see",
  ProtocolPatientPreviewList:
    'When you share a protocol, {{patientTermPlural}} can find them under the "protocols" tab in their {{patientTerm}} account.',
  ProtocolPatientPreviewEmail:
    "When you share with specific {{patientTermPlural}}, Fullscript sends an email on your behalf. Fullscript does NOT send an email when you share a protocol with all your {{patientTermPlural}}.",
  ProtocolPatientPreviewView:
    "If you copy and send a protocol link to your {{patientTermPlural}} it will take them directly into your protocol where they can view messages, attachments and products.",
  ShareProtocol: "Share protocol",
  ProtocolPatientPreviewEmailButton: "Will they get an email?",
  ProtocolPatientPreviewLinkButton: "What if they click a protocol link?",

  // Attachments
  Add: "Add",
  Customize: "Customize",
  Added: "Added",
  DocumentImage: "Document image",
  ViewMoreOptions: "View more options",
  FullscriptContent: "Fullscript content",
  YourLibrary: "Your library",
  AttachDocument: "Attach document",
  Done: "Done",
  Undo: "Undo",
  UploadNew: "Upload new",
  UndoUpload: "Undo upload",
  UploadFile: "Browse computer",
  UploadButtonText: "Browse computer",
  UploadAttachment: "Upload attachment",
  DropzoneText: "Drag and drop attachments",
  Or: "Or",
  OR: "OR",
  or: "or",
  UploadSuccess: "Upload successful",
  ReadyToUpload: "Ready to upload...",
  ReadyToUploadText: "File was attached, you can now upload it to the server, by clicking Upload ",
  SavedToLibrarySuccess: "Saved to your library",
  BrowseComputer: "Browse computer",
  SavedToLibrarySuccessText:
    "You can now access this attachment any time when {{treatmentPlanTermPresentParticiple}}.",
  UploadAnother: "Upload another file",
  SaveToYourLibrary: "Save to your library",
  HasBeenAttachedForOneTimeUse: "has been attached for one time use",
  AttachedForOneTimeUse: "Attached for one time use",
  NoResultsText: "No results matching",
  NoUploadsText: "No uploads found.",
  UploadHelpText:
    "Upload files from your computer and you'll be able to access them here for future use.",
  ConfirmDocumentDelete: "Are you sure you want to delete this document",
  LearnMore: "Learn more",
  LearnMoreAboutOurProcess: "Learn more about our process",
  RejectedFilesError: "File uploaded is not valid.",
  SomethingWentWrong: "Something went wrong, please try again",
  ElationPractitionerLogIn:
    "Could not find a matching Practitioner in Elation. Please have this Practitioner log into Fullscript through Elation to link their accounts, and then try again.",

  // social icons
  Facebook: "Facebook",
  CopyReferralLink: "Copy referral link",
  ReferralLinkCopied: "Your referral link was copied to your clipboard.",
  LinkedIn: "LinkedIn",
  Twitter: "Twitter",

  // Common Terms
  More: "More",
  MoreForUser: "More for {{- fullName}}",

  // Account Settings
  AccountSettings: "Account settings",
  Account: "Account",

  General: "General",
  Information: "Information",
  Info: "Info",
  InformationSubText:
    "The information here is what patients will see when you send them prescriptions, protocols or anything else through Fullscript.",
  UploadImage: "Upload Image",
  PractType: "Practitioner type",
  NeedToUpdate: " Need to change your practitioner type? <1>Upload a new certification</1>",
  Title: "Title",
  FirstName: "First Name",
  LastName: "Last Name",
  Suffix: "Suffix",
  RequiredFieldBlankError: "Cannot be blank or have opening spaces.",
  NameCannotContainEmojis: "Name cannot contain Emojis",

  NotificationSettings: "Notification Settings",
  Notifications: "Notifications",
  CloseNotifications: "Close notifications",
  HowYouWantNotified:
    "Select how you would like to receive notifications and emails from Fullscript.",
  SentNotificationsTo: "All notifications will be sent to:",
  UpdateEmail: "Update email",
  AccountsCreated: "Accounts created",
  ReceiveEmailAccountCreated:
    "Receive an email every time a new patient creates an account in your dispensary.",
  PatientOrders: "Patient orders",
  ReceiveEmailPatientOrders: "Receive an email every time an order is placed in your dispensary.",
  Shipments: "Shipments",
  ReceiveEmailShipments: "Receive an email every time a shipment has been sent to a patient.",
  InAppTerminology: "In-app terminology",
  ChooseTerminology:
    "Choose the terminology you would like presented throughout the app for you and your patients.",
  TreatmentTerm: "Treatment plan term",
  DefaultPrescription: "Prescription (Default)",
  Recommendation: "Recommendation",
  PatientTerm: "Patient term",
  DefaultPatient: "Patient (Default)",
  Client: "Client",

  Security: "Security",
  Password: "Password",
  YouNeverChangePassword: "You have never changed your password",
  ChangePassword: "Change your password",
  LoginSettings: "Login settings",
  UpdateYourLogin:
    "Updating your login email will change the email you use each time you sign into Fullscript.",
  AccountEmail: "Account email",
  ChangeEmail: "Change email",
  ChangeYourPassword: "Change your password",
  ChangePasswordCTA: "Change password",
  ForgotPassword: "Forgot password?",

  ChangeYourEmail: "Change your email",
  EnterNewEmail: "1. Enter a new email address.",
  WeWillVerifyYourEmail: "We'll send you an email to the new address to verify that you own it.",
  EnterYourPassword: "2. Enter your password.",
  EnterYourCurrentPassword: "Enter the password you currently use to login.",
  PasswordIsRequired: "Password is required",
  // favorites
  NoFavorites: "You haven't made any favorites yet",
  RemovedProductSuccessfully: "Removed {{product}} successfully",

  // Choose practitioner
  ChoosePractitionerForPlan: "Select which practitioner this plan is from...",
  StartPrescription: "Start {{treatmentPlanTerm}}",
  StartPlan: "Start plan",
  MyProfile: "My profile",

  // Supplement plans
  choosePractitionerForSupplementPlan: "Select which practitioner this supplement plan is from...",
  sendRequestCta: "Send request",

  LoadReplaceMessage:
    "A draft for {{- name}} already exists. Would you like to load the existing draft or replace it with this one?",
  Load: "Load",
  LoadMore: "Load more",
  XMore: "+{{ number }} more",
  ExploreAll: "Explore all",
  ShowingAllResults: "Showing all results",
  Replace: "Replace",

  ErrorProductNotFound: "Product not found",

  NoProtocolsHeader: "You don't have any protocols yet",
  NoProtocolsBody:
    "After you create protocols, they will appear here and you will be able to apply them to {{treatmentPlanTermPlural}}.",
  ApplyProtocolTitle: "Apply {{treatmentPlanTerm}} protocol for",
  Protocol: "Protocol",
  Protocols: "Protocols",
  UpdateProtocol: "Update protocol",
  NewProtocol: "New protocol",
  ViewProtocol: "View protocol",
  ViewProfile: "View profile",
  CreateProtocol: "Create protocol",
  AddProtocolName: "Add a protocol name",
  ProtocolUpdatedSuccessfully: "Protocol updated successfully!",
  ProtocolSharedSuccessfully: "Protocol shared successfully!",
  ProtocolDoesNotExist: "The protocol you requested does not exist.",
  ProtocolNeedsAName: "Protocol needs a name",
  ProtocolNotDirty: "Protocol hasn't changed",
  ResetDraftProtocolAlertMessage:
    "This will remove all content from the protocol. Are you sure you want to reset this draft?",
  ProtocolResetSuccessfully: "Draft protocol reset successfully!",
  OutOfStock: "Out of stock",
  Discontinued: "Discontinued",
  SelectADifferentSize: "Select a different size",
  addWithSubstitutes: "Add with substitutes",
  addWithSubstitution: "Add with substitution",
  editSubstitutes: "Edit substitutes",
  SwapWithCatalogProduct: "Swap with catalog product",
  SwapWithAProductInCatalog: "Swap with a different product",
  SwapDisabledReason: "You can only swap with products that are currently in stock.",
  Settings: "Settings",
  ProductOutOfStockOrDiscontinued:
    "This product cannot be purchased or prescribed because it is out of stock or discontinued",
  ProductNotWholesaleable:
    "This product is not available for wholesale purchase, but can be sent to your {{patientTerm}} through a {{treatmentPlanTerm}}. <2>Start a {{treatmentPlanTerm}}</2>",
  ProductNotWholesalableNolink:
    "This product is not available for wholesale purchase, but can be sent to your {{patientTerm}} through a plan.",
  KeepTrackOfPastSwaps: "Keep track of past swaps",
  KeepTrackofPastSwapsDescription:
    "Once you've swapped a product, you can view and unswap it here. In the meantime, check to see if any products need swapping.",
  ViewSwapsNeeded: "View swaps needed",
  WholesaleUnavailable: "Wholesale is unavailable for your account",
  UnavailableForWholesale: "Unavailable for wholesale",
  ProductNotWholesaleAvailable: "Product not available for wholesale purchase",
  OneProductNotWholesaleAvailable:
    "At least one product in this order is no longer available for wholesale purchase",
  QuantityAdded: "{{quantity}} added!",
  ViewCart: "View cart",

  // MAPs
  SupplierMapAgreement: "Supplier MAP policy",
  MAPModalFooterText:
    "MAP policies for all applicable brands can be found and referenced at our <1>Wholesale Policies</1> page.",
  IAgree: "I agree",
  MAPSpecificModalHeaderSubtext:
    "<0>Some of the brands offered through wholesale on Fullscript require you to opt-in to their individual MAP policy. <1>Scroll down to accept the terms.</1></0>",
  MAPStandardModalHeaderSubtext:
    "In order to resell products purchased from Fullscript, and prior to checking out, you are required to abide by and adhere to the original supplier's Minimum Advertised Price (MAP) policy or other such identified document.",

  // TOS
  UpdatedTOS: "We've recently updated our terms of service, effective September 1st, 2020.", // remove when replacing with actual copy
  ClickHereToView: "Click here to view",
  ariaLabelTOSLink: "click to view fullscript's terms of services",
  DownloadPdf: "Download PDF",
  BrowserCantOpenPdf:
    "We could not load the PDF in this browser. Please try again in a different browser.",
  MAPBrandTitle: "{{- brandName}} MAP",
  AcceptStandardMapPolicies:
    "By checking this box, I acknowledge and agree to abide by the MAP policy(ies) applicable to the products being purchased.",
  Ok: "Ok",
  OnlyDispensaryOwnersCanDoIt:
    "Only dispensary owners can agree to wholesale MAP policies. Please notify your dispensary owner if you wish to order this product.",
  YouMustScroll:
    "You must read and scroll to the bottom of the policy before you can agree to the terms.",

  // Showcase on my website modal
  showcase: {
    ShowcaseOnMyWebsite: "Showcase on my website",
    ShowThisProduct: "Show this product on your  website",
    CopyTagline:
      "Copy the code below onto your website so that {{patientTermPlural}} can buy this product direct.",
  },

  // FS tested
  fsTested: {
    Tested: "Tested",
    Title: "How was this product tested?",
    Tooltip: "Third party tested",
    Description:
      "At Fullscript, every brand meets our stringent quality standards – but we don't stop there. We handpick a select number of products from our catalog, focusing on key ingredient categories, and ship them from our inventory to a third-party lab for testing. The lab validates the products' potency and/or purity claims, ensuring they meet the highest standards.",
    Link: "Learn more about the testing methods",
  },

  // disclaimers
  FooterDisclaimerUS:
    "*These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.",
  cyberMondayDisclaimer:
    "To qualify for the 20% off offer, you must have a US healthcare professional or US student account. Upon qualifying for the offer, you will receive 20% off on participating brands and products available on wholesale orders. Offer starts November 27, 2023 at 12:00 a.m. ET, and ends November 29, 2023 at 2:59 a.m. ET. Any abuse of this offer, as determined by us in our sole discretion, may result in the rescission of the offer. Offer is subject to modification or termination at any time without notice in our sole discretion. Offer void where prohibited.",
  ProductRestricted: "This product has been restricted from your practitioner modality",
  Import: "Import",
  ImportModalTitle: "Import your Natural Partners data",
  ImportModalTextOne:
    "We've made it easier for you to bring over your data from Natural Partners so that it is accessible here on Fullscript.",
  ImportModalTextTwo:
    "Clicking the import button will take you to NaturalPartners.com in order to validate your credentials.",
  ImportModalTextThree:
    "Once validated, we will be able to import your previously ordered items from Natural Partners into your Fullscript account. You can easily find these products in search results. Your order history will also be updated to include these orders. Please note: some items are not available on Fullscript and will not be imported.",
  NpOrdersInProgress:
    "Your Fullscript account and Natural Partners account are being synchronized. While this operation is in progress some orders might be missing",
  ProductsAddedToCategory: "Products added to favorites",
  Saved: "Saved",
  Saving: "Saving...",
  AutoSaveMessage:
    "Fullscript auto saves your work. <1></1>Last saved {{lastUpdatedDate}} at {{lastUpdatedTime}}.",
  // Whats new modal catalog and wholesale
  WholesaleOnFs: "Wholesale on Fullscript",
  ProductCards: "Product cards",
  CartCheckout: "Cart and checkout",
  OrderHistory: "Order history",
  MapsTax: "MAPS and Tax exemption",
  BuyInOffice:
    "Talk about a convenient catalog! You can now buy products for your office/clinic on Fullscript. ",
  SamePrice: "Same price as buying direct from the manufacturer!",
  InOfficeFlexibility:
    "This gives you the flexibility of selling in-office and sending virtual {{treatmentPlanTermPlural}} — all from one platform.",
  ComingFromNP:
    "Coming from Natural Partners? You can import your data directly through Fullscript to make getting started a breeze.",
  OneClickOrdering:
    "Use our one-click reordering feature to restock, and easily track your shipments on the order history page.",
  OrderHistoryPage:
    "Our order history page makes it easy to track shipments, and use our one-click reordering feature to restock.",
  OnlyThisIngredient:
    'You can also use our "only this ingredient" feature to find matches containing only a specific ingredient.',
  WaysToDispense: "One product card. Multiple ways to dispense! ",
  WhenBrowsing:
    'When you browse products in the catalog, you\'ll see the wholesale price on the product card, and an "Add to cart" button as the main action.',
  WhatPatientsPay:
    "You can add a product to a virtual {{treatmentPlanTerm}} by clicking on the three vertical dots on the top right-hand side of the product card.",
  WhenYoureReady:
    'When you\'re ready to add a product to your cart, just click "Add to cart" — the counter on the wholesale button will increase.',
  YourNewExperience: "Your new supplement shopping experience.",
  ClickCart:
    "Click on the cart button in the navigation bar at the top of the page to see your subtotal. Proceed to checkout from there. ",
  NewDashboard: "On the order history page, you can:",
  ViewImportantInfo: "View important order details and information",
  ApplyForTaxExemption: "Apply for tax exemption",
  TellMeMore: "Tell me more",
  TryItNow: "Try it now!",
  StartWholesaleOrder: "Start wholesale order",
  WholesaleOrder: "Wholesale order",
  ProductsForInventory: "Products for inventory",
  ProductCardAltText: "A depiction of our new product cards and the information displayed.",
  IngredientSearchAltText: "A depiction of our new ingredient search experience.",
  WholesaleFsAltText: "Picture of two hands holding phones.",

  // Treatment plan view page
  PractitionerCount: "{{count}} practitioner",
  PractitionerCount_plural: "{{count}} practitioners",
  LabCount: "{{count}} lab",
  LabCount_plural: "{{count}} labs",
  Plans: "Plans",
  Orders: "Orders",
  ProductOrders: "Product orders",
  Options: "Options",
  FromPrac: "From {{-practitionerName}}",
  CreatedOn: "Created {{createdDate}}",
  UpdatedOn: "Updated {{lastUpdatedDate}}",
  UpcomingOn: "Upcoming {{upcomingDate}}",
  ViewPrescription: "View {{treatmentPlanTerm}}",
  DeletePrescription: "Delete {{treatmentPlanTerm}}",
  DeleteDraftPlanHeader: "Delete draft?",
  EditPrescription: "Edit {{treatmentPlanTerm}}",
  CancelPrescription: "Cancel {{treatmentPlanTerm}}",
  CancelPlanHeader: "Cancel plan?",
  CanceledSuccessfully: "{{treatmentPlanTermCapitalized}} has been canceled successfully",
  PlanCanceledSuccessfully: "Plan has been canceled successfully",
  DeleteSuccessfully: "{{treatmentPlanTermCapitalized}} has been deleted successfully",
  PlanDeletedSuccessfully: "Plan has been deleted successfully",
  TryAgain: "There was an error. Please try again",
  ViewOrder: "View order",
  AddToBasket: "Add to basket",
  AddToInOfficeCheckout: "Add to in-office checkout",
  AddToInOfficeCart: "Add to in-office cart",
  ProductAddedToInOfficeCartSuccess: "Product added to in-office cart successfully!",
  ProductAddedToBasketSuccess: "Product added to basket successfully!",
  ProductAddedToBasketError: "Failed to add product to basket",
  PatientDetails: "{{patientTermCapitalized}} details",
  PatientBasket: "{{patientTermCapitalized}} basket",
  InOfficeCart: "In-office cart",
  EmptyPatientBasket: "{{patientTermCapitalized}} basket is empty",
  EmptyInOfficeCart: "In-office cart is empty",
  PatientNeverSignedIn: "{{- patientFullName}} has never signed into their account",
  PatientLastSignedInTime: "last logged in on {{lastSignedInTime}}",
  PatientNeverSignedInLabel: "Never signed in",
  PatientSignedInLabel: "Signed in {{date}}",
  BackToAllPrescription: "Back to all {{treatmentPlanTermPluralized}}",
  BackToAllOrders: "Back to all orders",

  BackToPatientAllOrders: "Back to {{- patientFullName}}{{pluralize}} orders",
  PatientSavedSuccess: "{{patientTermCapitalized}} saved successfully",
  Actions: "Actions",
  BackToPatientInfo: "Back to {{patientTerm}} info",
  EditPatientName: "Edit: {{- fullName}}",
  treatmentPlanContentHeader:
    "Sent by: <1>{{- practitionerFullName}}<3> on</3> <4>{{date}}</4></1>",
  ArchivingPatientHeader: "Archive {{- fullName}}?",
  RestorePatientHeader: "You are about to restore {{- fullName}}",
  RestoringPatientDescription:
    "Are you sure you want to restore {{- fullName}}? They will be able to login again after this.",
  ArchivingPatientDescription:
    "The {{patientTerm}} will no longer have access to their Fullscript account.",
  ArchivingPatientAgree: "Archive {{patientTerm}}",
  ArchivingPatientDisagree: "Keep {{patientTerm}}",
  RestoringPatientAgree: "Yes, restore this {{patientTerm}}",
  RestoringPatientDisagree: "No, don't restore {{patientTerm}}",
  AreYouSureYouWantToDeletePrescription:
    "Are you sure you want to delete this {{treatmentPlanTerm}}?",
  NoAccessToDeletedDraftPlan: "You will no longer have access to this draft.",
  AreYouSureYouWantToCancelPrescription:
    "Are you sure you want to cancel this {{treatmentPlanTerm}}? Your {{patientTerm}} won't be able to access it later",
  NoAccessToCanceledPlan: "Your {{patientTerm}} will no longer have access to the plan.",
  DeleteDraftPlan: "Delete draft",
  CancelPlan: "Cancel plan",
  KeepPlan: "Keep plan",
  KeepDraft: "Keep draft",
  No: "No",
  EmbedURL: "Embed URL",
  Embed: "Embed",
  HyperlinkRemoved: "Hyperlink removed",
  HyperlinkCreated: "Hyperlink created",
  ResendTheEmail:
    "Resend the {{ treatmentPlanTerm }} email to your {{ patientTerm }} through Fullscript to remind them.",
  SendTextMessageReminderTitle: "Send text message reminder",
  SendTextMessageReminderDescription:
    "Send a text message to your {{patientTerm}} through Fullscript. Text messages lead to better adherence than emails alone. Standard message rates apply.",
  SendLinkTitle: "Send link",
  SendLinkDescription:
    "Copy and send this link to your {{patientTerm}}. They'll be prompted to sign in and view the plan you've made for them.",
  SendText: "Send text",
  CopyLink: "Copy link",
  CopyLinkToTP: "Copy link to your plan",
  CopyPlanNotes: "Copy plan notes",
  ViewAll: "View all",
  ViewDetails: "View details",
  Back: "Back",
  Avatar: "Avatar",
  ProductRemovedOn: "This product was <1>removed</1> on {{date}}",
  ProductDeleted: "This product has been deleted.",
  TreatmentPlanDoesNotExist: "The treatment plan you requested does not exist.",
  ProductsAndNotes: "Products and notes",
  ReviewPlan: "Review plan",
  ReviewTemplate: "Review Template",
  ViewPlan: "View plan",
  ViewPlans: "View plans",
  ReviewProtocol: "Review protocol",

  // Patient Integrations
  GoToIntegrations: "Go to integrations",

  // Order view page
  OrderWithNumber: "Order: {{number}}",
  OrderDetails: "Order details",
  DeliveryDetails: "Delivery details",
  OrderTotal: "Order totals",
  BillingAddress: "Billing address",
  ShippingAddress: "Shipping address",
  Subtotal: "Subtotal",
  Shipping: "Shipping",
  ProductsShipping: "Products shipping",
  LabsShipping: "Labs shipping",
  Tax: "Tax",
  PromotionSavings: "Promotion savings",
  DownloadReceipt: "Download receipt",
  DownloadProductsReceipt: "Download products receipt",
  DownloadLabsReceipt: "Download labs receipt",
  PrintReceipt: "Print receipt",
  PrintProductsReceipt: "Print products receipt",
  PrintLabsReceipt: "Print labs receipt",
  Returned: "Returned",
  Canceled: "Canceled",
  OrderPlaced: "Order placed",
  Pending: "Pending",
  Paid: "Paid",
  PaidByPractitioner: "Paid by practitioner",
  ReadyForShipment: "Ready for shipment",
  PartiallyShipped: "Partially shipped",
  Shipped: "Shipped",
  Autoship: "auto refills",
  ShippedOn: "Shipped on {{date}}",
  ShipmentCount: "Shipment {{number}}/{{total}}",
  TrackShipment: "Track shipment",
  AddAllToBasket: "Add all to basket",
  AddAllToInOfficeCheckout: "Add all to in-office checkout",
  NoShipmentFound: "No shipments found for this order",
  PaymentType: "Payment Information",
  IsNetTerms: "Net Terms",

  // Patient Index Page
  CheckboxAllSelected: "All",
  CheckboxPatientsSelected: "selected",
  CheckboxSelect: " Select ",
  CheckboxSelectAll: " Select all ",
  CheckboxAll: "All ",
  CheckboxOutOf: " out of ",
  CheckboxMatch: " that match your search",
  CheckboxSelected: " is selected",
  CheckboxSelected_plural: " are selected",
  Filter: "Filter",
  Filters: "Filters",
  ManagePatients: "Manage {{patientTermPlural}}",
  ManagePatientsDescription: "Easily view and manage all of your {{patientTerm}} information.",
  patientInfo: "{{patientTerm}} info",
  InOfficeCheckout: "In-office checkout",
  EditPatientProfile: "Edit {{patientTerm}} profile",
  NoOrders: "{{patientName}} hasn't ordered yet",
  NoPlatformOrders: "{{patientName}} doesn't have any {{platform}} orders",
  EmptyOrder: "There are no products in this order",
  EmptyPrescription: "There are no products in this plan",
  NoPrescriptions: "Once you create a plan, you can view and update it here.",
  NoPlatformPrescriptions:
    "There are no {{platform}} plans for this {{patientTerm}}. Once you create a plan, you can view and update it here.",
  NotInCatalogPractitioner:
    "Create a new {{treatmentPlanTerm}} and perform a search to replace this product.",
  CreateANewPrescription: "Create a new {{treatmentPlanTerm}}",
  CreateANewPrescriptionOrSendReminder:
    "Create a new {{treatmentPlanTerm}} or send a reminder to keep them on track.",
  BuildANewPlanOrSendReminder: "Build a new plan or send a reminder to keep them on track.",
  SearchForPatients: "Search for {{patientTerm}}s",
  SearchForPractitioner: "Search for practitioner",
  AllPractitioners: "All practitioners",
  ShowArchivedPatients: "Show archived patients",
  ShowPatientsWithDraft: "Only show patients with drafts",
  ShowPatientsWithFirstOrderDiscount: "Only show patients with a first order discount",
  PatientsWithDraft: "Draft available",
  PatientFirstOrderDiscount: "First order discount",
  NoPractitioner: "No practitioner",
  InFullscript: "In Fullscript",
  InWellevate: "In Wellevate",
  PatientStatus: "Patient status",
  NpSyncInProgress:
    "Your Natural Partners data is currently being imported. It will appear in <1>Wholesale Orders</1> once the sync is completed.",
  WholesaleLinkAria: "Link to wholesale orders page.",
  SyncInProgress: "Sync in progress",
  PatientModalChangesWarning: "Changes only apply to Fullscript {{patientTerm}} record",
  Notify: "Notify",
  CreateAsTemplate: "Create as template",
  ImportMultiplePatients: "Import multiple {{patientTermPlural}}",
  PatientEmptyState:
    "Once you create a {{patientTerm}} profile, manage their information and individual discounts here. Create an individual {{patientTerm}} or use our import tool to upload multiple profiles at once.",

  NotifyDescription:
    "Use our follow up options for better fulfillment. Text messages, direct links and email options are available.",
  ResendEmail: "Resend email",
  SeeMoreOptions: "See more options",
  ReminderEmailSent: "Reminder email sent to {{- patientName}}",
  All: "All",
  PractitionerCountAll: "All {{treatmentPlanTermPlural}}",
  PractitionerTreatmentPlans: "{{practitionerName}}",
  ReminderTextSent: "Reminder text sent to {{- patientName}}",
  LinkCopied: "Link copied",
  Export: "Export",
  ExportPlan: "Export plan",
  ViewPlainText: "View plain text",
  PDFDownload: "PDF download",
  Print: "Print",
  AmomentAgo: "Last logged in a moment ago",
  SecondsAgo: "Last logged in {{number}} seconds ago",
  AminuteAgo: "Last logged in a minute ago",
  MinutesAgo: "Last logged in {{number}} minutes ago",
  AnHourAgo: "Last logged in an hour ago",
  HoursAgo: "Last logged in {{number}} hours ago",
  AdayAgo: "Last logged in a day ago",
  DaysAgo: "Last logged in {{number}} days ago",
  AmonthAgo: "Last logged in a month ago",
  MonthsAgo: "Last logged in {{number}} months ago",
  AyearAgo: "Last logged in a year ago",
  YearsAgo: "Last logged in {{number}} years ago",
  ProductNotAvailablePurchase: "Product is not available for purchase",
  ProductRestrictedGeneric: "This product is restricted",

  // Patient profile page
  backToAllPatients: "Back to all {{ patientTermPlural }}",
  individualPlanTitle: "{{- firstName }}'s plan",
  individualPlanSubtitle: "Updated {{ updatedAt }}",

  // Labs
  Labs: "Labs",
  RegisterForLabs: "Register for labs",
  LabRemovedSuccessfully: "Lab removed successfully",
  LabAddedSuccessfully: "Lab added successfully",
  New: "New",
  LabOrders: "Lab orders",
  SearchByPatients: "Search by {{ patientTerm }} name or email",

  // Treatment plan link modal
  TreatmentPlanLinkModalHeader: "Treatment plan link",
  MultiPatientPlanLinkModalHeader: "Multi-{{ patientTerm }} plan link",
  CopyUrlFromTextArea:
    "We've detected that this browser doesn't support copying to clipboard.\nPlease copy this url manually.",

  // Treatment plan Plain Text
  TreatmentPlanPlainTextHeader: "Plan plain text",
  Message: "Message",
  AttachedDocuments: "Attached documents",
  SupplementRecommendations: "Supplement recommendations",
  PlainTextCopied: "Plain text copied",
  CopyPlainText: "Copy plain text",
  CopyPlainTextFromTextArea:
    "We've detected that this browser doesn't support copying to clipboard.\nPlease copy this text manually.",

  // Swapping/Swaps Page
  MassSwap: "Mass swap",
  SwapsPage: "Product swapping",
  SwapsNeeded: "Swaps needed",
  PastSwaps: "Past swaps",
  SwappedProducts: "Swapped products",
  SwappingDetails: "Details",
  SwappingDetailsDescription:
    "This will mass swap the old product for the new product in all {{treatmentPlanTermPlural}} from the last 3 months",
  SwappingSendEmailToPatients: "Send an email to affected {{patientTermPlural}}",
  SwapTheseProducts: "Swap these products",
  SwapTypeProduct: "{{swapProductType}} product",
  CancelSwap: "Cancel swap",
  SwapWith: "Swap with...",
  ProductUnswappedSuccesfully: "Product unswapped successfully",
  YourPatientsAreUpdated:
    "Your {{patientTermPlural}} {{treatmentPlanTermPlural}} have been updated",
  SelectDifferentProduct: "Select different product",
  SwapSuccess: "Swap success!",
  SwapSuccessfulToast: "Swap has been successful!",
  SwapSuccessDescription:
    "Successfully swapped the products in {{treatmentPlanTermPlural}} from the last 3 months",
  SwapHasBeenSwappedWith: "Has been swapped with...",
  SwapAnotherProduct: "Swap another product",
  UnswapProducts: "Unswap products",
  Unswap: "Unswap",
  SelectProductOnLeft: "Select a product on the left",
  SelectSimilarProduct:
    "You can swap with a similar product, curated by Fullscript's Medical Advisory team, or search for a product in our catalog.",
  SeeSimilarProducts: "See similar products",
  // Follow Up
  InReviewUpdateText: "Your 2020 Year in Review is ready!",
  SeeInReview: "🎉 See your stats",
  CloseFollowUp: "Close follow up",
  Continue: "Continue",
  WatchAgain: "Watch again",
  ClickToStart: "Let's start!",
  FollowUpHashTag: "#FullscriptFollowUp",
  PatientsHeader: "Your {{patientsTerm}} are your top priority. And we love that.",
  PatientsSubtext:
    "You helped a lot of people this year — but how many, exactly? Let's take a look at your breakdown of new and returning {{patientsTerm}}.",
  PatientsSubtext2:
    "The wider Fullscript patient community grew...well, wider this year! We now have more than 1 million patients receiving care.",
  RxHeader: "You've been busy!",
  RxSubtext:
    "We released a brand-new treatment plan tool in 2020, and launched shareable wellness protocols to support one-to-many care. So, how many recommendations did you send? And how does that compare to previous years?",
  TopFiveHeader: "Here's your Top 5.",
  TopFiveSubtext:
    "We added more popular brands and products to our catalog in 2020, including items for wholesale ordering. But we know you still have your tried, tested, and true favorites! Nice picks, by the way.",
  OrdersHeader: "Let's put things in perspective.",
  OrdersSubHeader:
    "It can be difficult for practitioners to measure their impact. Here are some numbers that really show your reach! Plus, since Fullscript was certified carbon-neutral in 2020, each shipment of supplements contributes to the health of the planet, as well as the health of your {{patientTerm}}!",
  TreesHeader: "You gave back.",
  TreesSubHeader:
    "We all believe in the power of integrative medicine, which means we have a deep appreciation of nature, and how it can heal us. Our certified offsets through Carbonzero mean that every order placed by your patients on Fullscript will directly contribute to afforestation.",
  InReviewFromFs: "<0>Fullscript 2020 </0>Follow Up",
  InReviewPage1Subtext:
    "<0>You worked hard — and so did your {{patientsTerm}}!</0> Let's take a moment to appreciate everything you and your practice accomplished this year.",
  InReviewEnding: "Thanks for following up!",
  InReviewEndingSubtext:
    "It was a year none of us will ever forget — full of unexpected challenges and change — but you really stepped up in 2020 to help keep people healthy. Congratulations, and don't forget to share your stats!",
  InReviewEndingSubtext2: "Thank you for being part of the Fullscript community. ",
  InReviewEndingSubtext3: "We can't wait to see the amazing things you'll do in 2021.",
  UnitsOrdered: "capsules sent",
  BottlesOrdered: "bottles packed",
  BoxesOrdered: "boxes shipped",
  TreesSaved: "Equivalent trees planted",
  CarbonOffset: "Kg of carbon offset",
  In2020: "in 2020",
  CreatedIn2020: "{{patientTerm}} added",
  ReturningPatients: "returning {{patientTerm}}",
  NewPatientsIn2020: "new ordering {{patientTerm}}",
  RxPercentThisYear:
    "{{percentage}}% of all your {{treatmentPlanTermPlural}} written with Fullscript were written this year!",
  RxSentThisYear: "{{treatmentPlanTermPlural}} sent in 2020",
  RxReturningPatients: "returning {{patientTermPlural}} this year",
  TopProducts: "Your top products",
  TopBrands: "Your top brands",
  PrescribedTimes: "times",
  ShareToSocialMedia: "Share to social media:",
  ShareOnFacebook: "Share on Facebook",
  ShareOnTwitter: "Share on Twitter",
  ShareOnInstagram: "Share on Instagram",
  ShareOnLinkedin: "Share on LinkedIn",
  DownloadAsImage: "Download for Instagram:",
  DownloadImage: "Download image",
  ShareWith: "Share with",
  WeTriedOurBest: "You shared your ideas. And we listened!",
  WeCollectedFeedback:
    "In 2020, we gathered more than 30,000 pieces of feedback from our practitioners and patients. We absorbed and considered every suggestion. All of that feedback was used to build and improve some of the game-changing features we released last year.",
  ProductAndEngineering:
    "Our product and engineering teams thank you — and ask you to keep it up in 2021!",
  CreateNew: "Create new",
  AddNewPatient: "Add new {{ patientTerm }}",
  CreateMultipleProfiles: "Create multiple profiles",
  NewPatientProfile: "New {{patientTerm}} profile",
  BuildAProtocol: "Build a protocol",
  OneToManyCare: "One-to-many care",
  IndividualCare: "Individual care",
  IndividualPlan: "Individual plan",
  IndividualPlan_plural: "Individual plans",
  OneToOneCare: "One-to-one care",
  MultiPatientPlan: "Multi-{{patientTerm}} plan",
  MultiPatientPlan_plural: "Multi-{{patientTerm}} plans",
  MultiPatientPlans: "Multi-{{patientTerm}} plans",
  ProductsFor: "Products for inventory",
  HealthyGut: "Healthy Gut",
  ImmuneSupport: "Immune Support",
  MensHealth: "Men's Health",
  Plus30: "+30",
  PlusMore: "+ {{count}} more",
  ViewNow: "View now",
  ViewProtocols: "View protocols",
  PillPacks: {
    DiscontinuePack: "Discontinue pack",
    EditPack: "Edit name / description",
    EditDailyPack: "Edit daily pack",
    AddedToDailyPack: "Added to Daily Pack",
    OneDailyPack: "1 Daily Pack",
    SaveAsStatic: "Save as static",
    SaveAsTemplate: "Save as template",
    ImatContentTooltip: "Add a pill to choose a daily pack type",
    CapsulesAdded: {
      default: "{{amQty}} capsules in the morning, {{pmQty}} capsules in the evening",
      amSingular: "{{amQty}} capsule in the morning, {{pmQty}} capsules in the evening",
      pmSingular: "{{amQty}} capsules in the morning, {{pmQty}} capsule in the evening",
      bothSingular: "{{amQty}} capsule in the morning, {{pmQty}} capsule in the evening",
    },
    SearchDailyPacks: "Search daily packs...",
    ExploreAllMyDailyPacks: "Explore all my daily packs",
    Customize: "Customize",
    CustomizeCreateNew: "Customize / Create new pack",
    CreateDailyPack: "Create daily pack",
    ViewDraft: "View draft",
    CreateForYourPatient: "Create a custom daily pack for your {{patientTerm}}.",
    Pills: "Pills",
    OneOrMoreDailyPacksIsInvalid: "One or more Daily Packs is invalid to send, please fix",
    AddedToPrescription: "Added Daily Pack to prescription",
    DailyPackAdded: "Daily pack added",
    Description: "Description",
    WhatsInside: "What's inside",
    BackToAllProducts: "Back to all products",
    PackOverfilled: "{{packType}} pack overfilled",
    Overfilled: "Each pack fits up to 8 items. Decrease dosages, or remove products.",
    AddProducts: "Add {{leftToFill}} more product(s)",
    TotalAmDosage: "Total AM dosage",
    TotalPmDosage: "Total PM dosage",
    AmDosage: "AM dosage",
    PmDosage: "PM dosage",
    NewDailyPack: "New daily pack",
    EditingDailyPack: "Editing daily pack",
    DailyPackName: "Daily Pack Name",
    AddName: "Add name",
    EditName: "Edit name",
    AddNameForTemplate: "Add name for template",
    TemplateInputPlaceholder: "Saved daily pack name",
    Name: "Name",
    InputPlaceholder: "Add name (ie Joe's Daily Pack)",
    Select3Products: "Select 3 products to get started.",
    CreatePack: "Create your {{patientTerm}}'s daily pack",
    ReadyMadeDailyPacks: "Ready-made daily packs ({{numberOfItems}})",
    MobileReadyMadeDailyPacks: "Ready-made daily packs",
    OrStartFromScratch: "Or, start from scratch",
    StartNewDailyPack: "Start new daily pack",
    UpdateDailyPack: "Update daily pack",
    SpeedUpYourWorkflow:
      "Speed up your workflow with packs created by the Fullscript medical advisory team",
    NewPill: "9 New",
    DailyPacks: "Daily packs",
    SimplifyYourPlan1:
      "Simplify your {{patientTerm}}'s plan and improve adherence. Curated, condition-specific daily packs are here.",
    FullscriptDailyPacksAreHere: "Fullscript Daily Packs are here",
    SimplifyYourPlan2:
      "Simplify your {{patientTerm}}'s plan and improve adherence with condition-specific daily packs.",
    RemindMeLater: "Remind me later",
    ExplorePacks: "Explore packs",
    PrescribeDailyPacks: "Prescribe daily packs",
    NotNow: "Not now",
    CannotModifyDosage: "Dosages cannot be modified for Fullscript Daily Packs",
    DailyPackProtocols: "Daily Pack protocols",
    ProtocolsBlurb:
      "Simplify your patient's plan and improve adherence. Curated, condition-specific daily packs are here.",
    ShareProtocols: "Share protocols",
    AddToDailyPack: "Add to daily pack",
    validation: {
      AddMoreProducts: "Add 3 or more products to a daily pack to send to a {{patientTerm}}",
      NotEnoughProducts: "Not enough products",
      AMOverfilled: "AM pack overfilled",
      PMOverfilled: "PM pack overfilled",
      OverfilledText:
        "Each pack fits up to 8 items. Decrease dosages or remove products to continue",
    },
    Item: "item",
    Items: "items",
    Product: "product",
    Products: "products",
    TermsAndConditions:
      "Fullscript is not responsible for monitoring your selections. You are solely responsible and assume full responsibility for the appropriateness of your selections, including uses, dosages, warnings, and contraindications. Fullscript disclaims any liability for claims, losses, injuries, or damages resulting from your selections.",
    NoneCreatedTitle: "No daily packs created",
    NoneCreatedBody: "Save your most frequently used daily pack combinations.",
    SaveDailyPack: "Save daily pack",
    DailyPackTemplateSaved: "Daily pack template added / saved",
    Total: "Total (1 month supply)",
    TemplateDeleted: "Template deleted",
    ViewYourDailyPack: "View your daily pack",
  },
  FullscriptProtocols: "Explore Fullscript protocols",
  PracticeOneToMany:
    "Practice one to many faster with Fullscript's evidence-based protocols available directly in your {{treatmentPlanTerm}} workflow",
  FeatureList: {
    WholesalePurchasing: {
      name: "Offering wholesale ordering",
      description:
        "In September 2020, we launched wholesale ordering in the Fullscript catalog, so regardless of whether you dispense virtually, in-office, or a combination of both, all of your supplement needs can be managed from one place.",
      metric: "Total dispensing freedom. One browser tab.",
    },
    WellnessContent: {
      name: "Launching patient wellness content",
      description:
        "Fullscript sends patients bi-weekly emails that contain practical, trustworthy content that's carefully researched by our Integrative Medical Advisory Team. These emails keep patients engaged, educated, and helps to keep your treatment plans top-of-mind!",
      metric: "Leads to a 15% boost in MSRP week over week for practitioners, on average.",
    },
    NewRxTool: {
      name: "Revolutionizing the treatment plan tool",
      description:
        "From game-changing tools like the industry's first ingredient search to simpler things — like an emoji library — the new treatment plan tool has a range of features practitioners were asking for, like: better search, a mobile-friendly experience, pre-loaded messages, faster load time, and a library of resources.",
      metric: "Write a personalized treatment plan in under a minute",
    },
    Promotions: {
      name: "Running two major promotions",
      description:
        "We ran two very successful promotions in 2020. These events are truly a win-win for practitioners and patients. Our June Promotion saw participating practitioners generating a 240% lift in revenue, on average. At the same time, patients saved money on the supplements they need.",
      metric:
        "In our 2020 Cyber Monday sale, 5,859 dispensaries opted in, and we reached 682,811 patients!",
    },
    NewPatientCatalog: {
      name: "Updating the patient catalog",
      description:
        "We made the patient experience mobile-friendly; simplified the navigation so it was easier to use, and with fewer steps; improved product search and filtering; displayed recently viewed products as well as new brands that get added to the catalog; and added more personalization to make the patient feel supported.",
      metric: "Getting patients what they need, faster.",
    },
    ShareableWellnessProtocols: {
      name: "Introducing shareable wellness protocols",
      description:
        "Practitioners gained the ability to share a general health protocol with all patients instantly. After the protocol is published, the platform generates a unique link to that protocol, which practitioners can then share publicly in emails, newsletters, and on their websites! This brings new and existing patients into the protocol to self-serve from the recommended products.",
      metric: "5,500+ NEW patients attracted to our practitioners' dispensaries",
    },
    CarbonNeutral: {
      name: "Going carbon-neutral",
      description:
        "In August 2020, we became a certified carbon-neutral organization, neutralizing our carbon footprint from January 1st, 2020 onwards. This involved calculating our total emissions as a company, measured in tonne CO2 equivalent (CO2e) — an enormous task that meant looking at the emissions of everything from our servers, to operations, and shipping.",
      metric: "Offset approximately 3400 tCO2e",
    },
    NewCatalog: {
      name: "Refreshing the catalog",
      description:
        "When we launched wholesale ordering on Fullscript, we also released a refreshed catalog experience.  Aside from adding wholesale products into the catalog, we updated it to reflect the same speed, search functionality, responsive design, and intuitive navigation that practitioners were enjoying in the new treatment plan tool.",
      metric: "More brands. Better search. Faster than ever.",
    },
    StudentAccounts: {
      name: "Supporting student ordering",
      description:
        "As part of our efforts to help grow and strengthen the integrative healthcare community, we updated the platform in 2020 to support student ordering accounts. This way, students with credentials that prove enrollment at an accredited institution — for a program that leads to a medical or an integrative health designation — could use certain Fullscript features.",
      metric: "Setting students up for success so they can hit the ground running.",
    },
    EHRIntegrations: {
      name: "Growing EHR integrations",
      description:
        "As part of our commitment to reduce tech complexity, streamline practitioner workflows, and meet our users where they are, we continued to improve our industry-leading EHR integrations.",
      metric:
        "We added Healthie, Unified Practice, Living Plate and more to our growing integrations community",
    },
    EngChanges: {
      name: "Continuously improving",
      description:
        "Our Product and engineering teams worked hard last year to deliver the best possible product for integrative practitioners. We had countless innovations in 2020, from big releases — like the ones listed above — to smaller iterations and improvements. We can't wait for you to see the exciting plans we have in store for 2021!",
      metric: "100+ platform improvements",
    },
  },
  Sort: "Sort",
  AlphabeticalAZ: "Alphabetical (A - Z)",
  AlphabeticalZA: "Alphabetical (Z - A)",
  RecentlyAdded: "Recently added",
  MostPrescribed: "Most {{treatmentPlanTermPastParticiple}}",
  MostRecommended: "Most recommended",
  PractitionerAssigned: "<0>Practitioner</0>: {{- firstPractitionerName}}",
  PractitionersAssigned:
    "<0>Practitioners</0>: {{- firstPractitionerName}} + {{selectedPractitionersCount}}",
  PractitionersAssignedArchived:
    "<0>Practitioners</0>: {{- firstPractitionerName}} (Archived) + {{selectedPractitionersCount}}",
  InvitationSent: "Invitation sent",
  InvitationSentToUser: "Invitation sent to {{- fullName}}",
  ResendInvite: "Resend invite",
  ResendInviteToUser: "Resent invite for {{- fullName}}",
  EditInfo: "Edit info",
  EditInfoForUser: "Edit info for {{- fullName}}",
  PatientCount: "{{patientTermCapitalized}} count",
  AddNew: "Add new",
  AddNewUser: "Add new user",
  NoOtherPractitioner: "No other practitioners in your dispensary",
  EmptyStaffList: {
    title: "Add staff to your dispensary",
    body: "Once you add staff, you can view and manage all of your staff accounts here.",
    cta: "Add staff",
  },
  Download: "Download",
  ReadOnly: "Read only",
  Product: "Product",
  Product_plural: "Products",
  DailyPack: "Daily pack",
  DailyPacks: "Daily packs",
  DailyPack_plural: "Daily packs",
  Resource: "Resource",
  Resources: "Resources",
  Resource_plural: "Resources",
  NumberProductsAdded: "{{recommendationsLength}} {{productTerm}}",
  NumberResourcesAdded: "{{attachmentsLength}} {{resourceTerm}}",
  Individual: "Individual",
  IndividualPlanDescription: "Customize your plan to a specific {{patientTerm}}'s needs.",
  MultiPatient: "Multi-{{patientTerm}}",
  MultiPlanDescription: "Extend your treatment reach with one-to-many care.",
  BuildPatientPlans: "Build {{patientTerm}} plans",
  BuildPatientPlanSubText:
    "Write an optimal supplement plan, quickly. Personalize it to an individual's needs, or share it with multiple {{patientsTerm}} at once.",
  AddPatientLabel: "Add {{patientTerm}}",
  BuildPlan: "Build plan",
  BuildPlanForPatients: "Build plan for {{pluralPatientTerm}}",
  BuildMultiPatientPlan: "Build multi-{{patientTerm}} plan",
  MyDispensaryTemplates: "My dispensary",
  BackToTemplates: "Back to Templates",
  TemplateSortNameAsc: "A-Z",
  TemplateSortNameDesc: "Z-A",
  TemplateSortNewest: "Newest",
  TemplateSortOldest: "Oldest",
  DailyPackSortNameAsc: "A-Z",
  DailyPackSortNameDesc: "Z-A",
  DailyPackSortNewest: "Newest",
  DailyPackSortOldest: "Oldest",
  FullscriptDailyPacksTitle: "Fullscript daily packs",
  FullscriptDailyPacksBody: "Created and reviewed by our Integrative Medical Advisory Team.",
  StaticDailyPacksTitle: "Static daily packs",
  StaticDailyPacksBody: "Created and reviewed by our Integrative Medical Advisory Team.",
  MyDailyPacks: "My daily packs",
  MadeByFullscript: "Made by Fullscript",
  FullscriptTemplateSubtext:
    "Pre-made plans developed using an <evidenceLink>evidence-informed approach</evidenceLink> — written and reviewed by our Integrative Medical Advisory Team.",
  CreateTemplate: "Create template",
  EvidenceBasedProtocol: "Evidence-based protocol",
  Evidence: "Evidence",
  SearchTemplates: "Search templates...",
  NewPlan: "New plan",
  EditPlan: "Edit plan",
  BackToPatientProfile: "Back to patient profile",
  Consultation: "Consultation",
  Review: "Review",
  CopyText: "Copy text",
  ExportToEHR: "Export to EHR",
  DraftTreatmentPlanCreatedSuccessfully: "Draft {{treatmentPlanTerm}} created",
  DraftTreatmentPlanCreatedSuccessfullyDescription:
    "The draft {{treatmentPlanTerm}} has been created and is ready for your review.",
  GoToPlan: "See {{treatmentPlanTerm}}",
  TextCopiedToClipboard: "Text copied to clipboard",
  LinkCopiedToClipboard: "Link copied to clipboard.",
  ShowFullText: "Show full text",
  ShowLessText: "Show less text",
  ProductDetails: "Product details",
  PrescriptionNotes: "{{treatmentPlanTermCapitalized}} notes",
  PatientNotes: "{{patientTermCapitalized}} notes",
  AddPatientNotes:
    "Add any other notes about your {{patientTerm}}. (e.g. SOAP notes or any other relevant health information)",
  AddPrescriptionNotes:
    "Add {{treatmentPlanTerm}} information for your {{patientTerm}}. (e.g. Take Progesterone, Estrogen and L-Theanine)",
  SuggestPlan: "Suggest plan",
  Category: "Category",
  LoadMessage: "Load message",
  MessageOptions: "Message options",
  GenerateMessage: "Generate message",
  CraftingMessage:
    "We are crafting your {{patientTerm}} a personalized message by leveraging hundreds of protocols, resources, and outcomes... it just takes a few seconds!",
  GeneratingMessage: "Generating message...",
  SavedMessages: "Saved messages",
  AiHelper: "AI Helper",
  LoadFromPreviouslySaved: "Load from previously saved",
  CreateMessagesInSeconds: "Create messages in seconds",
  AddSomeBasicInfo:
    "Add some basic information, and our technology will craft an informed, detailed message for you. Use this as a starting point for your message, then add your own content and details.",
  MakeShorter: "Make shorter",
  MakeLonger: "Make longer",
  OriginalMessage: "Original message",
  MessageOutput: "Message output",
  MessagePreview: "Message preview",
  AddToPlan: "Add to plan",
  AddAllToPlan: "Add all to plan",
  AddToMultiPatientPlan: "Add to multi-patient plan",
  AddOnsAvailable: "Add-ons available",
  AddToTemplate: "Add to template",
  ReplaceMessage: "Replace message",
  ConditionsAndHealthGoals: "Conditions and health goals",
  ConditionsAndHealthGoalsPlaceholder:
    "What are the {{patientTerm}} conditions and health goals? E.g. Sleep support, GI metabolism, pregnancy, etc.",
  IngredientRecommendations: "Ingredient recommendations",
  IngredientRecommendationsPlaceholder:
    "Which ingredients and products you are recommending for the {{patientTerm}}?",
  SpecialInstructions: "Special instructions",
  SpecialInstructionsPlaceholder: "Any special instructions for the {{patientTerm}}?",
  OptionalWithParentheses: "(optional)",
  Tone: "Tone",
  Tones: { neutral: "Neutral" },
  Neutral: "Neutral",
  OtherOptions: "Other options",
  Beta: "Beta",
  BetaLabelTooltipForIngredientSummary:
    "This feature is in beta. We work to ensure that information on this platform is correct; however, we cannot guarantee that all information is correct, complete or current.",
  BetaLabelTooltipForAutoplan:
    "This feature is being beta tested. The message provided may not be accurate or complete.",
  BasedOnyourDosageInstructionsWeIdentifiedAlternatives:
    "Based on your dosage instructions, we identified alternative options.",
  SupplementsTab: "Supplements & Personal Care",
  MedicationsTab: "Medications",
  DosageNonNumeric: "Dosage must be numeric",
  current_product: "Primary product",
  lower_cost: "Lowest cost",
  fewer_pills: "Fewest pills",
  higher_repurchase_rate: "Highest repurchase rate",
  is_fullscript_tested: "Tested",
  restricted: "Restricted access",
  reasonDescriptions: {
    lower_cost:
      "Products that offer a similar primary ingredient composition as the original product, but at a lower price per month.",
    fewer_pills:
      "Products that offer a similar primary ingredient composition as the original product, but require less intake, whether it be fewer pills, drops, scoops, etc.",
    higher_repurchase_rate:
      "Products that offer a similar primary ingredient composition as the original product, but are re-purchased by patients more often.",
  },
  MissingIngredients: "The following products are not included in this summary: ",
  adherenceFeedback: { responseMessage: "{{- firstName }} said on {{respondedAtFormatted}}:" },
  loading: "Loading",
  On: "On",
  Off: "Off",
  Dashboard: "Dashboard",
  ProductSubstitution: "Product substitution",
  Reports: "Reports",
  FinancialReports: "Financial reports",
  ReferralProgram: "Referral program",
  DispensarySettings: "Dispensary settings",
  StaffSettings: "Staff settings",
  CareCenter: "Catalog",
  Home: "Home",
  PatientPlans: "{{patientTermCapitalized}} plans",
  CareCenterDescription:
    "Explore our products, labs, templates and daily packs for your integrative care delivery.",
  OtherOptionsAvailable: "Other options available",
  WeFoundAlternatives: "We found alternatives with similar ingredients.",
  OptimizeYourProductChoice: "Optimize your product choice",
  Compare: "Compare",
  CompareProductsWithDifferentCriteria:
    "Compare products with lower prices, a higher reorder rate, or fewer pills per\u00A0dose.",
  CompareProducts: "Compare products",
  CompareProductsFraction: "Compare products ({{numOfProducts}}/{{maxNumOfProducts}})",
  CompareSimilarProducts: "Compare similar products",
  ProductCannotBeCompared:
    "This product can't be compared due to incomplete data needed for ingredient comparison.",
  WeFoundAlternativesWithDosages: "We found alternatives with similar ingredients and dosages.",
  ViewOptions: "View options",
  ThisProduct: "This product",
  Insights: "Insights",
  OriginalProduct: "Original product",
  CostValue: "Cost value",
  CostValueAria:
    "Bar chart showing cost value analysis between {{thisProduct}} and {{originalProduct}}",
  RepurchaseRateAria:
    "Bar chart showing repurchase rate analysis between {{thisProduct}} and {{originalProduct}}",
  RepurchaseRate: "Repurchase rate",
  Description: "Description",
  Certifications: "Certifications",
  AllergenIndicators: "Allergen indicators",
  WhyPreferredText: "Why is this a top pick for {{productCategory}}?",
  PreferredReasonInfo:
    "The Top Pick is selected to provide a quick way to identify high-quality, clinically effective products to meet common prescribing needs.\n\n" +
    "This product was selected based on the factors below:\n\n",
  Preferred: "Preferred",
  Month: "month",
  PersonalizedCare: "Personalized care sent to the {{patientTerm}}'s {{treatmentPlanTerm}} history",
  GeneralizedCare: "Generalized care shared on your dispensary catalog",
  OptimizedProducts: "Optimized products",
  CompareProductsDescription: "Compare products with similar ingredients and dosage.",
  CompareProductsPageDescription:
    "You can choose your own products or use Fullscript's suggestions.",
  BetaLabelTooltipForOptimizedProducts:
    "This feature is being beta tested. Based on your dosage instructions, we identified alternative options.",
  BackToTop: "Back to top",
  GoToAnalysis: "Go to analysis",
  CreatePatientProfiles: "Create patient profiles",
  Analysis: "Analysis",
  MonthlyCost: "Monthly cost",
  PricePerMonth: "${{ price }} / month",
  MonthlyPrice: "Monthly price",
  PercentageAmount: "{{ percentage }}%",
  Size: "Size",
  Form: "Form",
  WithFood: "With food",
  withFoodDosageText: "with food",
  selectProduct: "Select product",
  inTimeOfDay: "in the {{ timeOfDay }}",
  atTimeOfDay: "at {{ timeOfDay }}",

  // Patient Welcome Email Selection
  copyStoreLinkSuccess: "Store link copied successfully",
  inviteToFullscript: "Invite to Fullscript",

  noInvite: "Don't send invite email",
  InviteEmail: "Invite email",
  copyStoreLink: "Copy store link",
  send: "Send:",
  ThankYouForSharingYourFeedback: "Thank you for sharing your feedback",
  WhatIsTheReasonTheProductIsntRight:
    "What is the reason <1>{{productName}}</1> from <3>{{brandName}}</3> was not a good suggestion for you?",
  SendFeedback: "Send feedback",
  FeedbackSent: "Feedback sent",
  PleaseExpandOnTheReason: "Please expand on the reason",
  LacksKeyIngredients: "Missing key ingredients",
  NotAGoodBrandComparison: "Brand comparison concerns",
  PatientIncompatibility: "Patient incompatibility",
  BadExperienceInPast: "Negative past experience",
  Other: "Other",
  AdditionalReasoning: "Additional reasoning - {{additionalReasoning}}",
  Helpful: "Helpful?",
  GoodSuggestion: "Mark this as a good suggestion",
  BadSuggestion: "Tell us why this is a bad suggestion",
  AddInstructions: "Add instructions",
  AddLabsInstructionsHere: "Add lab instructions here",
  AddNotesToPatient: "Add note to {{ patientTerm }}",
  LabTests: "Lab tests",
  RequiresFasting: "Requires fasting",
  XYearsOld: "{{count}} years old",
  financialAddress: "Financial address",
  ClinicInformation: "Clinic information",

  // Current supplements plain text modal
  currentSupplementsPlainTextModalTitle: "Current supplements plain text",
  currentSupplementsPlainTextModalCurrentSupplements: "Current supplements:",
  currentSupplementsPlainTextModalDailyIngredientIntake: "Daily ingredient intake:",

  // Research Assistant
  Learn: "Learn",
  Ask: "Ask",
  Restart: "Restart",
  StartHere: "Start here ...",
  GenAiResearchAssistantPlaceholder:
    "Share details about the {{ patientTerm }}'s health concerns and conditions or paste a SOAP note.",
  WelcomeToResearchAssistant: "Welcome to your Research assistant",
  ResearchAssistantNote:
    "Once you add details about your {{ patientTerm }}, your AI research assistant will search information from peer reviewed medical archives to find articles that can help your research.",
  ResearchAssistantJudgment:
    "Generated by AI: This information is sourced from peer reviewed medical archives to aid your research process. Always use your best judgement.",
  CurrentSearch: "Current search:",
  HelpfulHints:
    "Helpful hints: Enter information such as the {{ patientTerm }}'s health condition, age, prenatal and biological sex.",
  ResearchAssistant: {
    title: "Research assistant",
    recommendedDose: "Recommended dose",
    generatedByAi: "Generated by AI",
    hint: "Health condition and additional information like age and prenatal, biological sex",
    noResultsFound:
      "Try adding more information such as your {{ patientTerm }}'s health condition, or you can paste your SOAP note.",
  },
  AiTreatmentPlanHelper: {
    aiGenerateModalTitle: "AI generate message",
    aiProofreadModalTitle: "AI proofreader",
    modifyTone: "Modify tone",
    professional: "Professional",
    friendly: "Friendly",
    concise: "Concise",
    replace: "Replace",
    cancel: "Cancel",
    refine: "Refine",
    fixErrors: "Fix errors",
    reformat: "Reformat",
    generateMessage: "Generate message",
    proofread: "Proofread",
    aiAssistance: "AI assistance",
    editMessage: "Edit message",
  },
  // Journeys
  Journeys: "Journeys",
  Journey: "Journey",
  VideoError: "Your browser doesn't support HTML video.",

  // emerson rso button
  emerson: "Emerson Ecologics Wholesale",
  rsoError: "Error directing to Emerson Ecologics",

  // Practitioner Analytics
  AnalyticsDashboard: "Analytics",

  CustomFeeInputs: {
    feeName: "Fee name",
    defaultFee: "Default fee",
    feeExceedError: "Fee can't exceed $1,000.00",
    types: {
      interpretation: "Interpretation fee",
      labNotesFee: "Lab notes fee",
      testAnalysisFee: "Test analysis fee",
      consultationFee: "Consultation fee",
    },
  },
  DraftConfirmationModal: {
    title: "You have an unsent draft",
    body: "A draft plan hasn't been sent yet. Would you like to continue working on this draft, or start a new plan?",
    bodyWithPatientName:
      "A draft plan written for {{ patientName }} hasn't been sent yet. Would you like to continue working on this draft, or start a new plan?",
    viewDraft: "View draft",
    startNew: "Start new plan",
  },
  loadMore: "Load more",
  PrimaryPatientDetails: "Primary patient details",
  managedByParent:
    "The parent will manage this {{ patientTerm }}'s account and receive all communications.",
  assignGuardianCheckbox: "This {{ patientTerm }} is under 18 years old",
  biologicalSex: "Biological sex (optional)",
  patientDiscount: "{{patientTermCapitalized}} discount:",
  patientDiscounts: "{{patientTermCapitalized}} discounts",
  firstOrderDiscountLabel: "First order discount:",
  selectAPatientToAssign:
    "Select a {{ patientTerm }} to assign as a parent to the {{ patientTerm }} you are creating. The {{ patientTerm }} must be over 18 years old.",
  parentIsAnExistingPatient: "Parent is existing {{ patientTerm }}?",
  additionalDetails: "Additional details",
  noResultsForQuery:
    'It looks like there are no results for "{{ query }}". Try clearing your search.',
  assignedPractitioners: "Assigned practitioners",
  noneSelected: "None selected",
  sendEmailInvite: "Send invitation email.",
  completeRequiredFields: "Complete all required fields",
  startWithSupplements: "Start with supplements",
  startWithLabs: "Start with labs",
  startWithTemplate: "Start with a template",
  parentManagesAccount:
    "A parent manages this {{ patientTerm }}'s account and receives communications.",
} as const;
